// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23fff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1,
h2,
h4,
h3,
h5,
h6,
body,
a,
button,
li {
    margin: 0;
    padding: 0;
    /* color: black!important; */
}

.dashboard-top-mine {
    background: #D3D8DB;
    height: 50px;
    width: 100%;
    border-radius: 15px 15px 0 0;
    padding: 1%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.dashboard-main-mine {
    margin-top: 3%;
    margin-left: 10px;
    border: 1px solid black;
    width: 98%;

    display: flex;
    flex-direction: column;

    border-radius: 15px;
}

.production-main-div {
    display: flex;
    justify-content: space-evenly;
    padding: 10px;
    flex-direction: row;
    flex-wrap: wrap;
    grid-column-gap: 10px;
    grid-row-gap: 10px;
}

.production-main-child {
    display: flex;
    justify-content: space-evenly;
    padding: 10px;
    color: white;
    flex-direction: column;
    flex-wrap: wrap;
    grid-column-gap: 10px;
    grid-row-gap: 10px;
}

.production-main-screen {
    width: 400px;
    height: 500px;
    background-color: #282b34;
    padding: 20px;
    display: flex;
    flex-direction: column;
    position: relative;
    align-items: flex-start;
    justify-content: flex-start;
    border-radius: 5px;
}

.screen-heading {

    color: white;
    font-size: 15px;

}

.screen-btn {
    width: 70%;
    margin-top: 10px;
    min-width: 150px;
    flex-direction: row;
    margin-right: 20px;
    align-items: center;
    display: flex;
    justify-content: flex-start;
    height: 60px;
    background-color: #3f4551;
    outline: none;
    border: none;
    border-radius: 10px;
}

.custom-input {
    width: '100%';
    min-width: 300px;
    height: 40px;
    background-color: rgba(53, 49, 49, 0.349);
    border-radius: 10px;
    outline: none;
    border: 1px solid rgba(236, 236, 236, 0.37);
    color: white;
    padding-left: 10px;
}

.slider-style>.rangeslider__fill {
    background-color: #4896bc !important
}

.slider-style {
    height: 7px !important;
}

.rangeslider__handle-label {
    display: none !important;
}

.slider-style>.rangeslider__handle {
    background-color: #4896bc !important
}

.barcode-btn {
    min-width: 70px;
    min-height: 30px;
    padding: 5px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    background-color: #3e87a8;
}

button {
    outline: none !important;
    border: none;
}

.card {
    width: 300px;
    height: 300px;
    background-color: rgb(98, 117, 223);
}

.container {
    padding: 2rem 0rem;
}

h4 {
    margin: 2rem 0rem;
}

.panel {
    border-radius: 4px;
    padding: 1rem;
    margin-top: 0.2rem;
    background-color: #F5F5F5;
    color: #323B40;
}

.panel.panel-blue {
    background-color: #E0F5FF;
    color: #00A5FA;
}

.panel.panel-big-height {
    min-height: 150px;
}

.item {
    border-radius: 4px;
    padding: 0.5rem;
    margin: 0.2rem;
}

.item.item-blue {
    background-color: #B9E5FE;
    color: #00A5FA;
}

.item.item-green {
    background-color: #B7E0DC;
    color: #019888;
}

.item.item-lime {
    background-color: #C7E8C8;
    color: #42B045;
}

.item.item-yellow {
    background-color: #FFEEBA;
    color: #FF9901;
}

.item.item-pink {
    background-color: #FABAD0;
    color: #EF075F;
}

.item.item-red {
    background-color: #FEC9C6;
    color: #FD3D08;
}

.item.item-big-width {
    min-width: 380px;
}

body {
    font-family: "Roboto", sans-serif;
}

.title {
    text-align: center;
    padding: 40px 0;
    font-size: 40px;
    font-weight: 300;
    color: #636983;
}





.container-1 {
    width: 100%;
    text-align: left;
}

input[type=checkbox].ckb {
    z-index: -1;
    opacity: 0;
}

input[type=checkbox].ckb+label {
    font-size: 18px;
    display: inline-flex;
    align-items: center;
    -webkit-user-select: none;
            user-select: none;
    cursor: pointer;
    transition: all 0.3s;
    color: #626981;
}

input[type=checkbox].ckb+label:hover {
    color: #2c5481;
}

input[type=checkbox].ckb+label::before {
    transition: all 0.3s;
    content: "";
    display: inline-block;
    width: 1em;
    height: 1em;
    flex-shrink: 0;
    flex-grow: 0;
    border: 1px solid #adb5bd;
    border-radius: 0.25em;
    margin-right: 0.5em;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 50% 50%;
    /* margin: 20px 5px; */
}

input[type=checkbox].ckb:checked+label::before {
    transition: all 0.3s;
    border-color: #2c5481;
    background-color: #2c5481;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    box-shadow: 2px 2px 10px 0px #9ebcff;
}

input[type=checkbox].ckb-success+label:hover {
    color: #1a7205;
}

input[type=checkbox].ckb-success:checked+label::before {
    border-color: #1a7205;
    background-color: #1a7205;
    box-shadow: 2px 2px 10px 0px #1a7205;
}

input[type=checkbox].ckb-default+label:hover {
    color: #636983;
}

input[type=checkbox].ckb-default:checked+label::before {
    border-color: #636983;
    background-color: #636983;
    box-shadow: 2px 2px 10px 0px #636983;
}

input[type=checkbox].ckb-warning+label:hover {
    color: #c81e1e;
}

input[type=checkbox].ckb-warning:checked+label::before {
    border-color: #c81e1e;
    background-color: #c81e1e;
    box-shadow: 2px 2px 10px 0px #ff9898;
}

input[type=checkbox].ckb-dark+label:hover {
    color: #505050;
}

input[type=checkbox].ckb-dark:checked+label::before {
    border-color: #505050;
    background-color: #505050;
    box-shadow: 2px 2px 10px 0px #9d9d9d;
}

.switch {
    position: relative;
    display: inline-block;
    width: 50px;
    height: 20px;
    margin: 9px;
}

.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}



input:checked+.slider-123 {
    background-color: #52c944;
}

input:focus+.slider-123 {
    box-shadow: 0 0 4px #7efa70;
}

input:checked+.slider-123:before {
    transform: translateX(26px);
}

.slider-123 {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: .4s cubic-bezier(0, 1, 0.5, 1);
    border-radius: 4px;
}

.slider-123:before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 4px;
    bottom: 2px;
    background-color: white;
    transition: .4s cubic-bezier(0, 1, 0.5, 1);
    border-radius: 3px;
}

/* Rounded sliders */
.slider-123.round {
    border-radius: 34px;
}

.slider-123.round:before {
    border-radius: 50%;
}

input:checked+.slider-123.red {
    background-color: crimson;
}

input:focus+.slider-123.red {
    box-shadow: 0 0 4px crimson;
}

input:checked+.slider-123.red {
    background-color: crimson;
}

#round {
    border-radius: 34px;
}

#round:before {
    border-radius: 50%;
}

input:checked+.slider-123.red {
    background-color: crimson;
}

input:focus+.slider-123.blue {
    box-shadow: 0 0 4px #424bf5;
}

input:checked+.slider-123.blue {
    background-color: #424bf5;
}

.user-locate-item {
    margin: 0;
    margin-top: 1%;
}

.store-locate-item {
    margin: 0;
}

.cycle-department {
    margin: 0;
}

.cycle-department-bold {
    margin: 0;
    font-style: bold;
    font-weight: 550;
}

.log-btn-cycle {
    width: 50px;
    height: 35px;
    border-radius: 10px;
    background-color: #3E87A8;
    display: flex;
    justify-content: center;
    align-items: center;
}

.log-text-cycle {

    margin: 0;
    color: white;
}

.cycle-light {
    width: 100%;
    height: 400px;
    border-radius: 10px;
    background-color: #3F4551;
    padding: 4%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.round-div {
    width: 180px;
    height: 180px;
    border: 10px solid grey;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.line-cycle {
    width: 100%;
    height: 1px;
    background-color: white;
}

.select-more-btn {
    width: 100%;
    height: 35px;
    border-radius: 10px;
    background-color: #3F4551;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 3%;
}

.select-more-continue {
    width: 100%;
    height: 35px;
    border-radius: 10px;
    background-color: #C82333;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 3%;
}

.select-more-text {
    color: white;
    margin: 0;
}

.screen-heading1 {

    color: white;
    font-size: 25px;
    font-weight: 500;

}

.screen-heading2 {

    color: white;
    font-size: 18px;
    font-weight: 500;
    margin-top: 3%;
}

.user-locate-item {
    margin: 0;
    margin-top: 1%;
    font-size: 15px;
}

.line-device {
    width: 100%;
    height: 4px;
    background-color: white;
    border-radius: 10px;
}

.round-div-new {
    width: 180px;
    height: 320px;


    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.purple-checkbox {
    border-radius: 100%;
}

[type="radio"]:not(:checked)+label:after {
    opacity: 0;
    transform: scale(0);
}

[type="radio"]:checked+label:after {
    opacity: 1;
    transform: scale(1);
}

.loading-center {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 2131;
}


td {
    background-color: rgb(28, 28, 28);
}


::-webkit-scrollbar {
    width: 5px;
    height: 5px
}

::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 5px
}

::-webkit-scrollbar-thumb {
    background: gray;
    border-radius: 0
}

::-webkit-scrollbar-thumb:hover {
    background: #b30000
}

body,
/* body * {
    font-family: 'Effra'
} */

html,
body {
    min-height: 100%;
    margin: 0;
    font-size: 14px;
    background-color: #373E43;
    color: #fff
}

/* a {
    color: #fff !important
} */
p {
    color: #FFF;
}

.active {
    background-color: #373E43
}

.wrapper {
    min-height: 100%;
    position: relative;
    overflow: hidden
}

.main-header {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    background-color: #091114;
    padding-left: 15.50%;
    z-index: 1
}

.main-footer {
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    padding-left: 15.50%;
    z-index: 1;
    background-color: #373E43
}

.main-footer p {
    margin-bottom: 0;
    color: #ddd;
    padding-bottom: 0 !important;
    padding-top: 2px !important;
    font-size: 13px
}

.main-sidebar,
.left-side {
    position: fixed;
    top: 0;
    left: 0;
    min-height: 100%;
    width: 15.50%;
    z-index: 810;
    background-color: #091114
}

.sidenav {
    margin-top: 10px
}

.content-wrapper {
    padding-top: 74px;
    background-color: #373E43;
    z-index: 800;
    margin-left: 15.50%
}

.light {
    color: #fff
}

.danger {
    color: #F41111
}

.logo {
    width: 90%;
    display: block;
    margin: auto
}

.fa-bars {
    font-size: 22px;
    line-height: 24px
}

.nav-text {
    color: white
}

aside a,
aside a:hover,
.nav-link,
.nav-link:hover,
aside p {
    color: #fff
}

aside .nav-link {
    font-size: 14px
}

.subMenuActive {
    padding-bottom: 10px;
    border-bottom: 2px solid #E81941
}

aside .nav-link img {
    height: 16px;
    vertical-align: text-bottom
}

header .navbar .navbar-nav .nav-item {
    text-align: center;
    border-right: 1px solid #FFF
}

header .navbar .navbar-nav .nav-item .nav-link {
    vertical-align: sub;
    /* padding:11px;padding-right:53px;*/
    min-width: 170px;
    font-size: 13px;
    text-align: center
}

header .navbar .navbar-nav .nav-item .nav-link img {
    height: 12px;
    margin-top: -8px;
    margin-right: 3px
}

.nav-link-collapse:after {
    float: left;
    content: "";
    font-family: "FontAwesome";
    padding-left: 5px
}

.nav-link-show:after {
    float: left;
    content: "";
    font-family: "FontAwesome"
}

.nav-item ul.nav-second-level {
    padding-left: 0
}

.nav-item ul.nav-second-level>.nav-item {
    padding-left: 45px
}

.nav-item ul.nav-second-level>.nav-item a {
    position: relative;
    padding-left: 25px
}

.nav-item ul.nav-second-level>.nav-item a img {
    position: absolute;
    left: 0;
    margin: 0;
    top: 12px
}

/* @media(min-width:992px){.sidenav{position:absolute;top:0;left:0;width:230px;height:calc(100vh - 3.5rem);margin-top:3.5rem;background:#343a40;box-sizing:border-box;border-top:1px solid rgba(0,0,0,0.3)}}*/
/* .navbar-expand-lg .sidenav{flex-direction:column}*/
aside .sidenav .nav-item .nav-link img {
    margin-left: 10px;
    margin-right: 5px;
    margin-top: -5px
}

aside .sub-nav span {
    font-size: 12px
}

.navbar-nav .nav-item:hover {
    background-color: #373E43
}

aside .sub-nav .nav-item {
    margin-bottom: 1px
}

aside .sub-nav .nav-item .nav-link {
    background-color: #a1a6a9
}

aside .sub-nav .nav-item .nav-link.active {
    background-color: #091114
}

.auth-sec img {
    vertical-align: middle;
    height: 16px
}

.auth-sec {
    padding: 10px 10px;
    margin-top: -47px;
    z-index: 10000;
    right: 0;
    position: absolute
}

.auth-sec span {
    color: #fff;
    font-size: 15px;
    line-height: 14px;
    text-transform: capitalize
}

.navbar-light .navbar-nav .nav-link {
    font-size: 14px
}

.navbar-light .navbar-nav .nav-link img {
    height: 16px
}

.content-wrapper .header-sec .nav-item {
    width: 170px;
    text-align: center;
    border-right: 1px solid #fff
}

.card {
    background-color: transparent;
    margin-top: 10px;
    border: 1px solid #151D20;
    border-radius: 10px !important
}

.card .card-header {
    background-color: #D3D8DB;
    border: none !important
}

.card-box {
    background-color: #091114;
    color: #D3D8DB;
    border-radius: 5px
}

.card-box h4 span {
    font-size: 18px
}

.card-box h2 {
    font-size: 90px
}

.card-box h2.lower-font {
    font-size: 62px;
    line-height: 62px
}

.card-box h2.sec-lower-font {
    font-size: 40px;
    line-height: 36px
}

.card-box-dark {
    background-color: #091114;
    color: #fff;
    border-radius: 5px
}

.card-box-dark h3 span {
    font-size: 16px
}

.filters .form-control {
    width: auto;
    min-width: 200px;
    background-color: transparent;
    color: #fff;
    font-weight: 500;
    border-radius: 10px;
    margin-left: 8px
}

.filters .form-control+.input-group-append.close {
    display: none !important
}

.filters .bs-searchbox .form-control {
    margin-left: 0
}

/*.filters #executiveSummary{background:#F41111;border:1px solid #F41111}*/
.filters button:focus {
    outline: 0 !important;
    box-shadow: none !important
}

.filters .btn-light {
    background: #373E43;
    color: white;
    outline: 0 !important;
    outline-offset: 0 !important;
    border-radius: 10px !important
}

.filters .inner.show ul li a.active {
    background: black !important
}

.filters .inner.show ul li a:active {
    background: black !important
}

.logo.mobile {
    display: none
}

select::-ms-expand {
    display: none
}

/* select{background:url(./angel-down.png)no-repeat right;background-position-x:166px;-webkit-appearance:none;-moz-appearance:none;appearance:none}*/
.v-align-middle {
    vertical-align: middle
}

.border-bottom-red {
    border-bottom-color: #d43f3a !important;
    border-bottom-width: 2px !important
}

@media only screen and(max-width:1100px) {
    .card-box h2 {
        font-size: 60px
    }

    .filters .form-control {
        min-width: 130px
    }

    .card-box h4 {
        font-size: 20px
    }

    .card-box-dark h4 {
        font-size: 19px
    }

    .card-box-dark h3 {
        font-size: 18px
    }

    .card-box-dark h3 span {
        font-size: 11px
    }

    .card-box h4 span {
        font-size: 16px
    }

    .card-box h2.lower-font {
        font-size: 40px;
        line-height: 60px
    }

    select {
        background-position-x: 100px
    }
}

@media only screen and(max-width:991px) {
    .main-sidebar {
        margin-top: 53px
    }

    .main-header {
        padding-left: 0
    }

    .navbar-nav {
        flex-direction: row
    }

    .main-sidebar .navbar-nav {
        flex-direction: column
    }

    .nav-text {
        text-transform: capitalize !important
    }

    .content-wrapper .header-sec .nav-item {
        width: 130px
    }

    .filters .form-control {
        margin-bottom: 10px
    }
}

@media only screen and(max-width:767px) {
    .nav-text {
        display: none
    }

    header .navbar .navbar-nav .nav-item {
        width: 60px
    }

    .logo.desktop {
        display: none
    }

    .logo.mobile {
        display: block;
        width: 100%
    }

    .d-none-sm {
        display: none
    }

    .ml-none-sm {
        margin-left: 0 !important
    }

    .main-sidebar {
        width: 50px
    }

    aside .nav-link img {
        height: 15px
    }

    aside .sub-nav .nav-link {
        padding-left: 8px !important
    }

    .content-wrapper {
        margin-left: 50px
    }

    .main-footer {
        padding-left: 50px;
        font-size: 9px
    }

    .content-wrapper .header-sec .nav-item {
        width: 69px
    }

    .content-wrapper .card-header .left h4 {
        font-size: 15px
    }

    .content-wrapper .card-header .left p {
        font-size: 10px
    }

    .content-wrapper .card-header .right {
        margin-top: 4px !important
    }

    .filters .form-control {
        min-width: 100%
    }

    .filters h4 {
        margin-bottom: 5px !important
    }

    .content-wrapper .card-header .right img {
        height: 20px !important
    }

    select {
        background-position-x: 95%
    }
}

select option {
    background-color: #373E43;
    color: #fff
}

.active2 {
    border-bottom: 1px solid #d90707;
    width: 89%;
    margin: auto
}

.content-wrapper {
    padding-left: 15px;
    padding-right: 15px
}

.dataTables_wrapper .dataTables_paginate .paginate_button {
    padding: 0 !important;
    background-color: #fff
}

.ti-stats-up {
    color: #fff
}

.header-title {
    color: #fff
}

.form-group label {
    color: #fff
}

.form-control {
    background-color: transparent;
    color: #fff
}

#dataTable_wrapper label {
    color: #fff
}

.chartjs-size-monitor * {
    color: #fff !important
}

table.dataTable tbody tr {
    background-color: transparent !important;
    color: #fff
}

table.dataTable tbody td {
    border: 1px solid #fff
}

#dataTable_info {
    color: #fff
}

.dataTables_filter label {
    color: #fff
}

.dataTables_length label {
    color: #fff
}

.bg-light * {
    background-color: #373E43;
    color: #fff
}

.bg-light th {
    border: 1px solid #fff !important;
    font-size: 13px
}

#dataTable td {
    font-size: 12px
}

.filter {
    background-color: #000
}

.filter label {
    margin-left: 10px;
    margin-right: 10px
}

.filter input,
.filter select,
.filter label {
    border-color: #4C9FE1 !important;
    color: #4C9FE1 !important
}

table.dataTable thead .sorting:before,
table.dataTable thead .sorting_asc:before,
table.dataTable thead .sorting_desc:before,
table.dataTable thead .sorting_asc_disabled:before,
table.dataTable thead .sorting_desc_disabled:before {
    display: none !important
}

table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after,
table.dataTable thead .sorting_asc_disabled:after,
table.dataTable thead .sorting_desc_disabled:after {
    display: none !important
}

.pagination a {
    background-color: #000 !important
}

.dataTables_length {
    display: none
}

#StoreID {
    width: 150px;
    height: 35px
}

#summarydate {
    width: 235px !important;
    height: 35px;
    border-radius: 10px
}

table.dataTable>tbody>tr.child ul.dtr-details>li:last-child {
    white-space: nowrap !important
}

.bootstrap-select>.dropdown-toggle.bs-placeholder,
.bootstrap-select>.dropdown-toggle.bs-placeholder:active,
.bootstrap-select>.dropdown-toggle.bs-placeholder:focus,
.bootstrap-select>.dropdown-toggle.bs-placeholder:hover {
    color: #fff !important;
    border-radius: 10px !important
}

.card {
    background-color: #373E43
}

.card-bg {
    background-color: #373E43 !important
}

.header-sec {
    display: none
}

table.dataTable thead th,
table.dataTable thead td {
    padding: 0 18px !important;
    border: 1px solid #ddd !important;
    box-sizing: border-box !important;
    border-bottom: 0 !important;
    letter-spacing: 1px
}

.progress-sec {
    margin-bottom: 5px;
    margin-left: 10px;
    clear: both
}

.header-sec .navbar-nav .nav-link {
    padding-top: 5px !important;
    padding-bottom: 10px !important
}

table.dataTable tbody th,
table.dataTable tbody td {
    padding: 2px 6px
}

table.dataTable button.btn.btn-default {
    padding: 0 5px !important;
    font-size: 14px
}

.card .card-header .right.float-right img {
    height: 20px;
    padding-right: 3px;
    padding-left: 3px
}

.userRole {
    height: 15px
}

.BtnAddList {
    position: absolute;
    right: 25px;
    top: 0;
    z-index: 999;
    margin-top: 75px;
    margin-bottom: 30px
}

.userRoleTable .form-control {
    min-width: 350px
}

.dataTables_wrapper .myfilter .dataTables_filter {
    float: left
}

.dataTables_wrapper .mylength .dataTables_length {
    float: right
}

table.dataTable tbody tr {
    font-size: 13px
}

.stockSummaryTable table.dataTable.dtr-inline.collapsed>tbody>tr[role=row]>td:first-child:before,
table.dataTable.dtr-inline.collapsed>tbody>tr[role=row]>th:first-child:before {
    top: 4px !important
}

.userInfoFilter .filters {
    display: inline
}

.userInfoFilter .dataTables_filter {
    margin-top: -30px
}

table.dataTable.dtr-inline.collapsed>tbody>tr[role=row]>td:first-child:before,
table.dataTable.dtr-inline.collapsed>tbody>tr[role=row]>th:first-child:before {
    top: 2px !important;
    height: 12px;
    width: 12px
}

table.dataTable.dtr-inline.collapsed>tbody>tr[role=row]>td:first-child,
table.dataTable.dtr-inline.collapsed>tbody>tr[role=row]>th:first-child {
    padding-left: 5px
}

.stocksummery .dataTables_filter .form-control {
    width: 280px
}

#dataTable12_wrapper .dataTables_filter .form-control {
    width: 280px
}

/* .dataTables_filter .form-control{width:280px !important}*/
.customNav {
    background: #091114;
    padding: 0 !important
}

.customNav .navbar-nav li a {
    color: #fff
}

.customNav .navbar-nav li .dropdown-item:hover {
    background: none !important
}

li.float-right.nav-item {
    position: absolute;
    right: 0
}

.customNav .dropdown-menu {
    background: #373E43;
    border: none !important;
    border-radius: 0;
    margin: 0 !important;
    padding-top: 0;
    text-align: left
}

.CustomsubMenu {
    display: flex
}

.customNav .dropdown-menu .CustomsubMenu a {
    display: inline-block;
    position: relative;
    margin-right: 0;
    background: none !important;
    padding-bottom: 7px;
    font-size: 13px;
    width: 170px
}

.customNav .dropdown-menu .CustomsubMenu a:after {
    content: "";
    position: absolute;
    width: 1px;
    height: calc(100% - 8px);
    background: white;
    right: 0;
    top: 5px
}

.customNav .dropdown-menu .dropdown-item {
    padding: .25rem 1.0rem
}

.customNav .dropdown-menu>.px-0 {
    overflow-x: auto;
    width: 100%;
    overflow-y: hidden
}

.customNav .dropdown-menu>.px-0 .CustomsubMenu {
    white-space: nowrap;
    padding-bottom: 5px;
    display: block;
    font-size: 0
}

.customNav .dropdown-menu>.px-0 .CustomsubMenu a {
    /*display:inline-block;width:170px !important;*/
    text-align: center
}

.customNav .navbar-nav a {}

.customNav .dropdown-menu .CustomsubMenu a img {
    height: 12px;
    margin-top: -2px;
    margin-right: 5px
}

.customNav .dropdown-toggle::after {
    display: none
}

.card .card-header .mb-0 {
    font-size: 18px;
    color: #373E43
}

.run.btn-block {
    display: block;
    width: 54%;
    color: #fff;
    background-color: #0069d9;
    border-color: #0062cc;
    border-radius: 10px
}

.run:hover {
    color: #fff;
    background-color: #0069d9;
    border-color: #0062cc
}

.run:not(:disabled):not(.disabled).active,
.run:not(:disabled):not(.disabled):active,
.show>.run.dropdown-toggle {
    color: #fff;
    background-color: #0062cc;
    border-color: #005cbf
}

.run.focus,
.run:focus {
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5) !important
}

.inner_col_stock_wrapper {
    text-align: center;
    background: #000;
    padding: 10px;
    border-radius: 10px;
    margin: 0 5px 5px 5px
}

.inner_col_stock_wrapper .main_heading_stock {
    color: #B4BF17;
    font-size: 14px
}

.inner_col_stock_wrapper .para {
    color: #fff;
    margin-bottom: 6px
}

.stockSummaryTable .left.d-inline-block {
    font-size: 18px
}

#dashboard .dash_board {
    border: 1px solid #707070 !important;
    border-radius: 10px !important;
    padding: 0 !important;
    padding-bottom: 15px !important
}

#dashboard .dash_board .card-header {
    width: calc(100% + 2px) !important;
    border-radius: 10px 10px 0 0 !important;
    margin-left: -1px;
    margin-top: -1px
}

#dashboard .dash_board .card.second {
    margin-top: 15px !important
}

#dashboard .dash_board .card.full {
    height: calc(100% - 10px)
}

#dashboard .dash_board .card-body h2 {}

#dashboard .dash_board .card-body h2 p {
    margin-bottom: 0 !important;
    color: #fff
}

#dashboard .activities {
    height: 310px;
    overflow: hidden;
    overflow-y: auto
}

#dashboard .activities .card-body h3 {
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 20px
}

#dashboard .activities .card-body #Activities {
    height: auto
}

#dashboard .activities .card-body #Activities p {
    font-size: 12px;
    font-weight: 300;
    margin-bottom: 0.5rem;
    line-height: 10px
}

#dashboard button.btn.dropdown-toggle.bs-placeholder.btn-light {
    width: 50%;
    background-color: #373E43
}

.btn-light:not(:disabled):not(.disabled):active:focus,
.show>.btn-light.dropdown-toggle:focus,
.btn-light.focus,
.btn-light:focus {
    box-shadow: none
}

.btn-light {
    border-color: none
}

.bootstrap-select .dropdown-toggle:focus {
    outline: 0 auto -webkit-focus-ring-color !important
}

#dashboard>.col-12 {
    padding-left: 0 !important;
    padding-right: 0 !important
}

#dashboard .crdBody {
    padding: 10px 5px
}

#dashboard .crdBody p {
    color: #C3F432;
    font-size: 20px;
    line-height: 5px
}

#dashboard #expectedw,
#dashboard #totalstore,
#dashboard #item_accuracy {
    font-weight: bold
}

#dashboard #expectedw p,
#dashboard #totalstore p,
#dashboard #item_accuracy p {
    font-weight: bold
}

#dashboard .mainsupplychaincard {
    border-radius: 10px
}

#dashboard .mainsupplychaincard .card-header {
    border-radius: 10px 10px 0 0
}

#dashboard .mainsupplychaincard .supplychaincardbody {
    border-radius: 0 0 10px 10px
}

#dashboard .mainsupplychaincard .supplychaincardbody .supplychaincard {
    height: auto
}

@media screen and(max-width:767px) {
    #dashboard .mainsupplychaincard .supplychaincardbody .supplychaincard {
        height: auto
    }
}

#dashboard .mainsupplychaincard .supplychaincardbody h4,
#dashboard .mainsupplychaincard .supplychaincardbody h6 {
    font-size: 20px;
    color: #fff;
    line-height: normal;
    font-weight: 400
}

#dashboard .mainsupplychaincard .supplychaincardbody .class_supply_week p,
#dashboard .mainsupplychaincard .supplychaincardbody .class_supply_month p {
    font-size: 16px;
    color: #fff;
    line-height: 16px;
    font-weight: 400
}

#dashboard .mainsupplychaincard .supplychaincardbody .class_supply_week h4 span,
#dashboard .mainsupplychaincard .supplychaincardbody .class_supply_month h4 span {
    font-size: 55px;
    color: #fff;
    line-height: 65px;
    font-weight: 400
}

#dashboard .mainsupplychaincard .supplychaincardbody .cardsupply_asn {
    background: #091114;
    border-color: #091114
}

#dashboard .mainsupplychaincard .supplychaincardbody .cardsupply_asn .supplymain_heading1 h6 {
    color: #F41111
}

#dashboard .mainsupplychaincard .supplychaincardbody .cardsupply_asn .supplymain_heading2 h6 {
    color: #15BE3C
}

#dashboard .mainsupplychaincard .supplychaincardbody .cardsupply_asn.shortage h6 {
    color: #F41111
}

#dashboard .mainsupplychaincard .supplychaincardbody .cardsupply_asn.excess h6 {
    color: #15BE3C
}

#dashboard .mainsupplychaincard .supplychaincardbody .cardsupply_asn h4 {
    font-size: 100px;
    line-height: 106px;
    color: #fff
}

#dashboard .mainsupplychaincard .supplychaincardbody .supplychaincard p span {
    font-size: 70px;
    line-height: 80px;
    color: #fff
}

#dashboard .black-card {
    background: #091114;
    border-color: #091114
}

#dashboard .black-card .card-body>span,
#dashboard .black-card .card-body>span span,
#dashboard .black-card .card-body .progress-sec p {
    color: #fff
}

#dashboard .black-card .mainCard {
    background-color: #2A3034;
    border-radius: 10px
}

/* #item_accuracy p,
#operational_accuracy p {
    color: #000
} */

::-webkit-calendar-picker-indicator {
    filter: invert(1)
}

.main-footer {
    padding-bottom: 5px
}

.navbar-nav>li {
    background: #373E43;
    border-bottom: 1px solid #091114
}

.navbar-nav>li.active>a:after {
    transform: rotate(0deg);
    transition: 0.5s
}

.navbar-nav>li>a {
    padding-left: 8px !important
}

.navbar-nav>li>a:after {
    transform: rotate(-90deg);
    transition: 0.5s;
    padding-left: 0
}

.navbar-nav>li>ul>li {
    background: #56626A;
    position: relative
}

.navbar-nav>li>ul>li:not(:last-of-type) {
    border-bottom: 1px solid #091114
}

.navbar-nav>li>ul>li:first-of-type {
    border-top: 1px solid #091114
}

.navbar-nav>li>ul>li:before {
    content: "";
    position: absolute;
    height: 0;
    width: 2px;
    left: 0;
    transition: 0.5s
}

.navbar-nav>li>ul>li.active {
    background: #091114;
    transition: 0.5s
}

.navbar-nav>li>ul>li.active:before {
    height: 100%;
    background: #E81941;
    transition: 0.5s
}

.main-header ul>li {
    border-bottom: 0;
    border-right: 0 !important;
    background: #151D20
}

.main-header ul>li>a {
    position: relative
}

.main-header ul>li>a:before {
    content: "";
    position: absolute;
    width: 1px;
    height: calc(100% - 8px);
    background: white;
    right: 0;
    top: 5px
}

.main-header ul>li .dropdown-menu .subMenuActive {
    position: relative;
    border-bottom: 0
}

.main-header ul>li .dropdown-menu .subMenuActive:before {
    content: "";
    position: absolute;
    width: calc(100% - 12px);
    height: 2px;
    background: #E81941;
    border-radius: 50px;
    left: 0;
    right: 0;
    margin: auto;
    bottom: -2px
}

.top-cards {
    min-height: auto
}

.success {
    color: #15BE3C
}

#onehand2 .accu-onhand-vl,
#CriticalStock .accu-onhand-vl {
    font-size: 35px
}

#undernum p,
#expectednum p {
    font-size: 35px;
    display: inline
}

#PrinterForm .container {
    max-width: 100%;
    padding: 0
}

#PrinterForm .container .inner_form {
    min-height: 100%
}

#PrinterForm .container>.row {
    margin-left: -7.5px;
    margin-right: -7.5px
}

#PrinterForm .container>.row>div {
    padding-left: 7.5px;
    padding-right: 7.5px
}

#dashboard .cad .card-header h4 {
    font-size: 18px;
    font-weight: 500;
    color: #373E43
}

#dashboard .cad .card-header p {
    font-size: 15px;
    font-weight: 300;
    color: #373E43
}

#dashboard .cad .crdBody p {
    font-size: 14px;
    font-weight: 300
}

#dashboard .cad .card-body h2 p {
    font-size: 90px;
    font-weight: 400 !important;
    text-align: center
}

#dashboard .cad .card-body #expectedw p {
    text-align: center !important
}

#dashboard .cad .card-body .progress-sec p {
    font-size: 16px;
    display: inline-flex !important
}

#dashboard .cad .card-body span,
#dashboard .cad .card-body h6 {
    font-weight: 500;
    font-size: 16px
}

#dashboard .cad .card-body .itemHeading {
    font-weight: 400
}

#dashboard .cad .card-body .dropdown-item span {
    font-weight: 300;
    font-size: 16px;
    line-height: 35px
}

#dashboard .cad .card-body .filter-option-inner-inner {
    font-size: 16px
}

.bg-warning {
    background-color: #39DD4C !important
}

.bg-danger {
    background-color: #E3174E !important
}

.bg-info {
    background-color: #47ACE2 !important
}

.pagination li a {
    background-color: white !important;
    color: black !important
}

#executive-summary-count-dashboard h4 {
    font-size: 18px;
    font-weight: 500;
    color: #373E43
}

#executive-summary-count-dashboard p {
    font-size: 18px;
    font-weight: 300;
    color: #373E43
}

#executive-summary-count-dashboard .card-box p,
#executive-summary-count-dashboard .card-box h4 {
    color: #fff
}

#executive-summary-count-dashboard .item-accuracy-card p {
    font-size: 100px;
    font-weight: 400
}

#executive-summary-count-dashboard .item-accuracy-count h2 {
    font-size: 85px;
    font-weight: 400
}

#executive-summary-count-dashboard .item-accuracy-front-back h2 {
    font-size: 50px;
    font-weight: 400
}

#executive-summary-count-dashboard .black-right-card:last-of-type {
    padding-bottom: 22px !important
}

#executive-summary-count-dashboard .black-right-card span {
    font-size: 25px;
    font-weight: 500
}

#executive-summary-count-dashboard .black-right-card .small-text {
    font-size: 16px;
    font-weight: 300
}

#executive-summary-count-dashboard .black-right-card p {
    font-size: 25px;
    font-weight: 300
}

#executive-summary-count-dashboard .black-right-card h4 {
    font-size: 18px;
    font-weight: 300
}

.page-item.active .page-link {
    border: 0
}

.card-header:first-child {
    border-radius: 10px 10px 0 0;
    padding: 8px 10px
}

.time-load-text {
    margin: 0;
    padding: 0 !important;
    position: absolute;
    right: 10px;
    font-size: 10px !important;
    bottom: 5px
}

.dashboard-new .card {
    height: 100%
}

.content-wrapper .right {
    margin-top: 11px !important
}

.content-wrapper .right img {
    height: 25px !important
}

.last-scan-row {
    width: calc(100% + 30px);
    margin: 0;
    margin-left: -15px
}

#Activities::-webkit-scrollbar {
    width: 10px
}

#Activities::-webkit-scrollbar-track {
    box-shadow: none
}

#Activities::-webkit-scrollbar-thumb {
    background-color: darkgrey;
    outline: none;
    border-radius: 10px
}

#CountDynamic {
    height: none
}

.crdBody h4 {
    min-height: 27px
}

.card-header h4 {
    font-size: 25px;
    font-weight: 300
}

.card-header .dateTime {
    font-size: 13px !important;
    font-weight: 300
}

.custom-filter h4 {
    font-size: 25px;
    font-weight: 300
}

.custom-filter .inner.show ul li a.active {
    background: black !important
}

.side-banner {
    /* background-image: url(/assets/images/side-banner.png); */
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover
}

.dash-theme-dark.top-bar {
    color: #fff
}

@keyframes spinner {
    to {
        transform: rotate(360deg)
    }
}

.spinner:before {
    content: '';
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 50px;
    height: 50px;
    margin-top: -10px;
    margin-left: -10px;
    border-radius: 50%;
    border: 2px solid #ccc;
    border-top-color: #333;
    animation: spinner .6s linear infinite
}

.dataTables_wrapper .dataTables_processing {
    height: 150px
}

.dataTables_wrapper .dataTables_processing {
    min-height: 120px !important
}

.dt-buttons {
    display: none
}

.data-tables {
    visibility: hidden
}

.before_load_table {
    text-align: center
}

.before_load_table img {
    width: 100px
}

.filter_container {
    width: 98%;
    max-width: 100%
}

.custom-filter h4 {
    margin-left: 15px
}

#Onhand,
#Count,
#back,
#front {
    font-size: 27px !important
}

#Onhand span,
#Count span,
#back span,
#front span {
    font-size: 27px !important
}

.dropdown-menu {
    background-color: #151d20;
    color: #fff
}

.dropdown-item:focus,
.dropdown-item:hover {
    background-color: #171b1d
}

table.dataTable tbody {
    background-color: #1b1f22
}

table.dataTable tbody td {
    padding: 0 !important;
    border-top: 0 !important
}

.dataTables_wrapper.no-footer .dataTables_scrollBody {
    border-bottom: 0 !important
}

.BtnAdd {
    border-radius: 10px
}

.error {
    color: red !important;
}

div.dataTables_wrapper div.dataTables_processing {
    background: transparent !important;
    color: #fff !important;
    border: none !important;
}

@media print {

    html,
    body {
        border: 1px solid white;
        height: 99%;
        page-break-after: avoid;
        page-break-before: avoid;
        color: #000;
        background: #fff
    }
}

input[disabled] {
    background-color: rgb(180, 180, 180) !important;
}

.page-link-btn {
    color: white !important;
}

/* .MuiInputBase-input {
    height: 0.7rem!important;
  } */

.button-custom {
    background: #3390fa;
    border-radius: 10px;
    width: max-content;
    padding: 5px 10px;
    color: #fff;
    text-decoration: none;
    font-size: 1em;
    margin: 0 15px;
}

/* Hover state animation applied here */
.button-custom:hover {
    animation: hover 1200ms linear 2 alternate;
}

/* Active state animation applied here */
.button-custom:active {
    animation: active 1200ms ease 1 alternate;
    background: #5F9BE0;
}

.gray {
    background: #D2D2D2;
}

.gray:active {
    background: #b9b9b9;
}

/* Active state animation keyframes below */

@keyframes active {
    0% {
        transform: scale(1, 1);
    }

    90% {
        transform: scale(.9, .88);
    }

    100% {
        transform: scale(.92, .9);
    }
}

/* Hover state animation keyframes below */

@keyframes hover {
    0% {
        transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    1.8% {
        transform: matrix3d(1.016, 0, 0, 0, 0, 1.037, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    3.5% {
        transform: matrix3d(1.033, 0, 0, 0, 0, 1.094, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    4.7% {
        transform: matrix3d(1.045, 0, 0, 0, 0, 1.129, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    5.31% {
        transform: matrix3d(1.051, 0, 0, 0, 0, 1.142, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    7.01% {
        transform: matrix3d(1.068, 0, 0, 0, 0, 1.158, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    8.91% {
        transform: matrix3d(1.084, 0, 0, 0, 0, 1.141, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    9.41% {
        transform: matrix3d(1.088, 0, 0, 0, 0, 1.132, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    10.71% {
        transform: matrix3d(1.097, 0, 0, 0, 0, 1.107, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    12.61% {
        transform: matrix3d(1.108, 0, 0, 0, 0, 1.077, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    14.11% {
        transform: matrix3d(1.114, 0, 0, 0, 0, 1.067, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    14.41% {
        transform: matrix3d(1.115, 0, 0, 0, 0, 1.067, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    16.32% {
        transform: matrix3d(1.119, 0, 0, 0, 0, 1.077, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    18.12% {
        transform: matrix3d(1.121, 0, 0, 0, 0, 1.096, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    18.72% {
        transform: matrix3d(1.121, 0, 0, 0, 0, 1.102, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    20.02% {
        transform: matrix3d(1.121, 0, 0, 0, 0, 1.113, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    21.82% {
        transform: matrix3d(1.119, 0, 0, 0, 0, 1.119, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    24.32% {
        transform: matrix3d(1.115, 0, 0, 0, 0, 1.11, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    25.53% {
        transform: matrix3d(1.113, 0, 0, 0, 0, 1.102, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    29.23% {
        transform: matrix3d(1.106, 0, 0, 0, 0, 1.089, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    29.93% {
        transform: matrix3d(1.105, 0, 0, 0, 0, 1.09, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    35.54% {
        transform: matrix3d(1.098, 0, 0, 0, 0, 1.105, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    36.64% {
        transform: matrix3d(1.097, 0, 0, 0, 0, 1.106, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    41.04% {
        transform: matrix3d(1.096, 0, 0, 0, 0, 1.099, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    44.04% {
        transform: matrix3d(1.096, 0, 0, 0, 0, 1.097, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    51.45% {
        transform: matrix3d(1.099, 0, 0, 0, 0, 1.102, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    52.15% {
        transform: matrix3d(1.099, 0, 0, 0, 0, 1.102, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    58.86% {
        transform: matrix3d(1.101, 0, 0, 0, 0, 1.099, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    63.26% {
        transform: matrix3d(1.101, 0, 0, 0, 0, 1.1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    66.27% {
        transform: matrix3d(1.101, 0, 0, 0, 0, 1.101, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    73.77% {
        transform: matrix3d(1.1, 0, 0, 0, 0, 1.1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    81.18% {
        transform: matrix3d(1.1, 0, 0, 0, 0, 1.1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    85.49% {
        transform: matrix3d(1.1, 0, 0, 0, 0, 1.1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    88.59% {
        transform: matrix3d(1.1, 0, 0, 0, 0, 1.1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    96% {
        transform: matrix3d(1.1, 0, 0, 0, 0, 1.1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    100% {
        transform: matrix3d(1.1, 0, 0, 0, 0, 1.1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }
}

.printer-modal .MuiPaper-root {
    background-color: #555656!important;
}`, "",{"version":3,"sources":["webpack://./src/css/mine.css"],"names":[],"mappings":"AAAA;;;;;;;;;;IAUI,SAAS;IACT,UAAU;IACV,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,4BAA4B;IAC5B,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,uBAAuB;IACvB,UAAU;;IAEV,aAAa;IACb,sBAAsB;;IAEtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;;IAEI,YAAY;IACZ,eAAe;;AAEnB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,2BAA2B;IAC3B,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,yCAAyC;IACzC,mBAAmB;IACnB,aAAa;IACb,2CAA2C;IAC3C,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;IACxB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAIA;IACI,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;;;;;AAMA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,yBAAiB;YAAjB,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,cAAc;IACd,YAAY;IACZ,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;IACnB,4BAA4B;IAC5B,kCAAkC;IAClC,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,yBAAyB;IACzB,yDAA6M;IAC7M,oCAAoC;AACxC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,oCAAoC;AACxC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,oCAAoC;AACxC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,oCAAoC;AACxC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,SAAS;AACb;;;;AAIA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IAGI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IAEtB,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;IACT,WAAW;IACX,uBAAuB;IAEvB,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA,oBAAoB;AACpB;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;;IAEI,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,SAAS;AACb;;AAEA;;IAEI,YAAY;IACZ,eAAe;IACf,gBAAgB;;AAEpB;;AAEA;;IAEI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;;;IAGb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;IAEV,mBAAmB;AACvB;;AAEA;IACI,UAAU;IAEV,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gCAAgC;IAChC,aAAa;AACjB;;;AAGA;IACI,iCAAiC;AACrC;;;AAQA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;;IAOI,gBAAgB;IAChB,SAAS;IACT,eAAe;IACf,yBAAyB;IACzB;AACJ;;AAEA;;GAEG;AACH;IACI,WAAW;AACf;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,OAAO;IACP,yBAAyB;IACzB,oBAAoB;IACpB;AACJ;;AAEA;IACI,eAAe;IACf,SAAS;IACT,QAAQ;IACR,OAAO;IACP,oBAAoB;IACpB,UAAU;IACV;AACJ;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,4BAA4B;IAC5B,2BAA2B;IAC3B;AACJ;;AAEA;;IAEI,eAAe;IACf,MAAM;IACN,OAAO;IACP,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,cAAc;IACd;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,oCAAoC;IACpC,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT;AACJ;;AAEA,6MAA6M;AAC7M,qDAAqD;AACrD;IACI,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,QAAQ;IACR;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,6BAA6B;IAC7B,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA,0EAA0E;AAC1E;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,4BAA4B;IAC5B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA,oJAAoJ;AACpJ;IACI;AACJ;;AAEA;IACI,uCAAuC;IACvC;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,gCAAgC;IAChC,UAAU;IACV;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wCAAwC;IACxC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,iCAAiC;IACjC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;;;IAGI,gCAAgC;IAChC;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,0BAA0B;IAC1B,iCAAiC;IACjC,iCAAiC;IACjC,2BAA2B;IAC3B;AACJ;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,YAAY;IACZ,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,mBAAmB;IACnB,YAAY;IACZ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA,4DAA4D;AAC5D;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,oBAAoB;IACpB,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,wBAAwB;IACxB,iBAAiB;IACjB,QAAQ;IACR;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX;AACJ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd;AACJ;;AAEA;IACI,+CAA+C;IAC/C;AACJ;;AAEA,0BAA0B;;AAE1B;IACI,YAAY;IACZ,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;IACd,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;IAGI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oCAAoC;IACpC,8BAA8B;IAC9B,qBAAqB;IACrB;AACJ;;AAEA;IACI,kCAAkC;IAClC,uCAAuC;IACvC,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA,sCAAsC;;AAEtC;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB;AACJ;;AAEA;;IAEI,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB;AACJ;;AAEA;;IAEI,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;;;GAGG;;AAEH;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,uBAAuB;IACvB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,OAAO;IACP;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB;AACJ;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,wBAAwB;IACxB,iBAAiB;IACjB,QAAQ;IACR;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,wBAAwB;IACxB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;;IAEI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kCAAkC;IAClC;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI,SAAS;IACT,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wBAAwB;IACxB,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2DAA2D;IAC3D,4BAA4B;IAC5B,2BAA2B;IAC3B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kCAAkC;IAClC,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;;IAEI;;QAEI,uBAAuB;QACvB,WAAW;QACX,uBAAuB;QACvB,wBAAwB;QACxB,WAAW;QACX;IACJ;AACJ;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;KAEK;;AAEL;IACI,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,qBAAqB;IACrB,cAAc;IACd,cAAc;AAClB;;AAEA,uCAAuC;AACvC;IAEI,0CAA0C;AAC9C;;AAEA,wCAAwC;AACxC;IAEI,yCAAyC;IACzC,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,2CAA2C;;AAgB3C;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA,0CAA0C;;AAwL1C;IACI;QAEI,mEAAmE;IACvE;;IAEA;QAEI,2EAA2E;IAC/E;;IAEA;QAEI,2EAA2E;IAC/E;;IAEA;QAEI,2EAA2E;IAC/E;;IAEA;QAEI,2EAA2E;IAC/E;;IAEA;QAEI,2EAA2E;IAC/E;;IAEA;QAEI,2EAA2E;IAC/E;;IAEA;QAEI,2EAA2E;IAC/E;;IAEA;QAEI,2EAA2E;IAC/E;;IAEA;QAEI,2EAA2E;IAC/E;;IAEA;QAEI,2EAA2E;IAC/E;;IAEA;QAEI,2EAA2E;IAC/E;;IAEA;QAEI,2EAA2E;IAC/E;;IAEA;QAEI,2EAA2E;IAC/E;;IAEA;QAEI,2EAA2E;IAC/E;;IAEA;QAEI,2EAA2E;IAC/E;;IAEA;QAEI,2EAA2E;IAC/E;;IAEA;QAEI,0EAA0E;IAC9E;;IAEA;QAEI,2EAA2E;IAC/E;;IAEA;QAEI,2EAA2E;IAC/E;;IAEA;QAEI,0EAA0E;IAC9E;;IAEA;QAEI,2EAA2E;IAC/E;;IAEA;QAEI,2EAA2E;IAC/E;;IAEA;QAEI,2EAA2E;IAC/E;;IAEA;QAEI,2EAA2E;IAC/E;;IAEA;QAEI,2EAA2E;IAC/E;;IAEA;QAEI,2EAA2E;IAC/E;;IAEA;QAEI,2EAA2E;IAC/E;;IAEA;QAEI,yEAAyE;IAC7E;;IAEA;QAEI,2EAA2E;IAC/E;;IAEA;QAEI,uEAAuE;IAC3E;;IAEA;QAEI,uEAAuE;IAC3E;;IAEA;QAEI,uEAAuE;IAC3E;;IAEA;QAEI,uEAAuE;IAC3E;;IAEA;QAEI,uEAAuE;IAC3E;;IAEA;QAEI,uEAAuE;IAC3E;AACJ;;AAEA;IACI,mCAAmC;AACvC","sourcesContent":["h1,\nh2,\nh4,\nh3,\nh5,\nh6,\nbody,\na,\nbutton,\nli {\n    margin: 0;\n    padding: 0;\n    /* color: black!important; */\n}\n\n.dashboard-top-mine {\n    background: #D3D8DB;\n    height: 50px;\n    width: 100%;\n    border-radius: 15px 15px 0 0;\n    padding: 1%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.dashboard-main-mine {\n    margin-top: 3%;\n    margin-left: 10px;\n    border: 1px solid black;\n    width: 98%;\n\n    display: flex;\n    flex-direction: column;\n\n    border-radius: 15px;\n}\n\n.production-main-div {\n    display: flex;\n    justify-content: space-evenly;\n    padding: 10px;\n    flex-direction: row;\n    flex-wrap: wrap;\n    grid-column-gap: 10px;\n    grid-row-gap: 10px;\n}\n\n.production-main-child {\n    display: flex;\n    justify-content: space-evenly;\n    padding: 10px;\n    color: white;\n    flex-direction: column;\n    flex-wrap: wrap;\n    grid-column-gap: 10px;\n    grid-row-gap: 10px;\n}\n\n.production-main-screen {\n    width: 400px;\n    height: 500px;\n    background-color: #282b34;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    align-items: flex-start;\n    justify-content: flex-start;\n    border-radius: 5px;\n}\n\n.screen-heading {\n\n    color: white;\n    font-size: 15px;\n\n}\n\n.screen-btn {\n    width: 70%;\n    margin-top: 10px;\n    min-width: 150px;\n    flex-direction: row;\n    margin-right: 20px;\n    align-items: center;\n    display: flex;\n    justify-content: flex-start;\n    height: 60px;\n    background-color: #3f4551;\n    outline: none;\n    border: none;\n    border-radius: 10px;\n}\n\n.custom-input {\n    width: '100%';\n    min-width: 300px;\n    height: 40px;\n    background-color: rgba(53, 49, 49, 0.349);\n    border-radius: 10px;\n    outline: none;\n    border: 1px solid rgba(236, 236, 236, 0.37);\n    color: white;\n    padding-left: 10px;\n}\n\n.slider-style>.rangeslider__fill {\n    background-color: #4896bc !important\n}\n\n.slider-style {\n    height: 7px !important;\n}\n\n.rangeslider__handle-label {\n    display: none !important;\n}\n\n.slider-style>.rangeslider__handle {\n    background-color: #4896bc !important\n}\n\n.barcode-btn {\n    min-width: 70px;\n    min-height: 30px;\n    padding: 5px;\n    border-radius: 10px;\n    display: flex;\n    justify-content: center;\n    background-color: #3e87a8;\n}\n\nbutton {\n    outline: none !important;\n    border: none;\n}\n\n.card {\n    width: 300px;\n    height: 300px;\n    background-color: rgb(98, 117, 223);\n}\n\n.container {\n    padding: 2rem 0rem;\n}\n\nh4 {\n    margin: 2rem 0rem;\n}\n\n.panel {\n    border-radius: 4px;\n    padding: 1rem;\n    margin-top: 0.2rem;\n    background-color: #F5F5F5;\n    color: #323B40;\n}\n\n.panel.panel-blue {\n    background-color: #E0F5FF;\n    color: #00A5FA;\n}\n\n.panel.panel-big-height {\n    min-height: 150px;\n}\n\n.item {\n    border-radius: 4px;\n    padding: 0.5rem;\n    margin: 0.2rem;\n}\n\n.item.item-blue {\n    background-color: #B9E5FE;\n    color: #00A5FA;\n}\n\n.item.item-green {\n    background-color: #B7E0DC;\n    color: #019888;\n}\n\n.item.item-lime {\n    background-color: #C7E8C8;\n    color: #42B045;\n}\n\n.item.item-yellow {\n    background-color: #FFEEBA;\n    color: #FF9901;\n}\n\n.item.item-pink {\n    background-color: #FABAD0;\n    color: #EF075F;\n}\n\n.item.item-red {\n    background-color: #FEC9C6;\n    color: #FD3D08;\n}\n\n.item.item-big-width {\n    min-width: 380px;\n}\n\n@import url(\"https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap\");\n\nbody {\n    font-family: \"Roboto\", sans-serif;\n}\n\n.title {\n    text-align: center;\n    padding: 40px 0;\n    font-size: 40px;\n    font-weight: 300;\n    color: #636983;\n}\n\n\n\n\n\n.container-1 {\n    width: 100%;\n    text-align: left;\n}\n\ninput[type=checkbox].ckb {\n    z-index: -1;\n    opacity: 0;\n}\n\ninput[type=checkbox].ckb+label {\n    font-size: 18px;\n    display: inline-flex;\n    align-items: center;\n    user-select: none;\n    cursor: pointer;\n    transition: all 0.3s;\n    color: #626981;\n}\n\ninput[type=checkbox].ckb+label:hover {\n    color: #2c5481;\n}\n\ninput[type=checkbox].ckb+label::before {\n    transition: all 0.3s;\n    content: \"\";\n    display: inline-block;\n    width: 1em;\n    height: 1em;\n    flex-shrink: 0;\n    flex-grow: 0;\n    border: 1px solid #adb5bd;\n    border-radius: 0.25em;\n    margin-right: 0.5em;\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: 50% 50%;\n    /* margin: 20px 5px; */\n}\n\ninput[type=checkbox].ckb:checked+label::before {\n    transition: all 0.3s;\n    border-color: #2c5481;\n    background-color: #2c5481;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3e%3c/svg%3e\");\n    box-shadow: 2px 2px 10px 0px #9ebcff;\n}\n\ninput[type=checkbox].ckb-success+label:hover {\n    color: #1a7205;\n}\n\ninput[type=checkbox].ckb-success:checked+label::before {\n    border-color: #1a7205;\n    background-color: #1a7205;\n    box-shadow: 2px 2px 10px 0px #1a7205;\n}\n\ninput[type=checkbox].ckb-default+label:hover {\n    color: #636983;\n}\n\ninput[type=checkbox].ckb-default:checked+label::before {\n    border-color: #636983;\n    background-color: #636983;\n    box-shadow: 2px 2px 10px 0px #636983;\n}\n\ninput[type=checkbox].ckb-warning+label:hover {\n    color: #c81e1e;\n}\n\ninput[type=checkbox].ckb-warning:checked+label::before {\n    border-color: #c81e1e;\n    background-color: #c81e1e;\n    box-shadow: 2px 2px 10px 0px #ff9898;\n}\n\ninput[type=checkbox].ckb-dark+label:hover {\n    color: #505050;\n}\n\ninput[type=checkbox].ckb-dark:checked+label::before {\n    border-color: #505050;\n    background-color: #505050;\n    box-shadow: 2px 2px 10px 0px #9d9d9d;\n}\n\n.switch {\n    position: relative;\n    display: inline-block;\n    width: 50px;\n    height: 20px;\n    margin: 9px;\n}\n\n.switch input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n}\n\n\n\ninput:checked+.slider-123 {\n    background-color: #52c944;\n}\n\ninput:focus+.slider-123 {\n    box-shadow: 0 0 4px #7efa70;\n}\n\ninput:checked+.slider-123:before {\n    -webkit-transform: translateX(26px);\n    -ms-transform: translateX(26px);\n    transform: translateX(26px);\n}\n\n.slider-123 {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #ccc;\n    -webkit-transition: .4s;\n    transition: .4s cubic-bezier(0, 1, 0.5, 1);\n    border-radius: 4px;\n}\n\n.slider-123:before {\n    position: absolute;\n    content: \"\";\n    height: 16px;\n    width: 16px;\n    left: 4px;\n    bottom: 2px;\n    background-color: white;\n    -webkit-transition: .4s;\n    transition: .4s cubic-bezier(0, 1, 0.5, 1);\n    border-radius: 3px;\n}\n\n/* Rounded sliders */\n.slider-123.round {\n    border-radius: 34px;\n}\n\n.slider-123.round:before {\n    border-radius: 50%;\n}\n\ninput:checked+.slider-123.red {\n    background-color: crimson;\n}\n\ninput:focus+.slider-123.red {\n    box-shadow: 0 0 4px crimson;\n}\n\ninput:checked+.slider-123.red {\n    background-color: crimson;\n}\n\n#round {\n    border-radius: 34px;\n}\n\n#round:before {\n    border-radius: 50%;\n}\n\ninput:checked+.slider-123.red {\n    background-color: crimson;\n}\n\ninput:focus+.slider-123.blue {\n    box-shadow: 0 0 4px #424bf5;\n}\n\ninput:checked+.slider-123.blue {\n    background-color: #424bf5;\n}\n\n.user-locate-item {\n    margin: 0;\n    margin-top: 1%;\n}\n\n.store-locate-item {\n    margin: 0;\n}\n\n.cycle-department {\n    margin: 0;\n}\n\n.cycle-department-bold {\n    margin: 0;\n    font-style: bold;\n    font-weight: 550;\n}\n\n.log-btn-cycle {\n    width: 50px;\n    height: 35px;\n    border-radius: 10px;\n    background-color: #3E87A8;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.log-text-cycle {\n\n    margin: 0;\n    color: white;\n}\n\n.cycle-light {\n    width: 100%;\n    height: 400px;\n    border-radius: 10px;\n    background-color: #3F4551;\n    padding: 4%;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n.round-div {\n    width: 180px;\n    height: 180px;\n    border: 10px solid grey;\n    border-radius: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n}\n\n.line-cycle {\n    width: 100%;\n    height: 1px;\n    background-color: white;\n}\n\n.select-more-btn {\n    width: 100%;\n    height: 35px;\n    border-radius: 10px;\n    background-color: #3F4551;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 3%;\n}\n\n.select-more-continue {\n    width: 100%;\n    height: 35px;\n    border-radius: 10px;\n    background-color: #C82333;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 3%;\n}\n\n.select-more-text {\n    color: white;\n    margin: 0;\n}\n\n.screen-heading1 {\n\n    color: white;\n    font-size: 25px;\n    font-weight: 500;\n\n}\n\n.screen-heading2 {\n\n    color: white;\n    font-size: 18px;\n    font-weight: 500;\n    margin-top: 3%;\n}\n\n.user-locate-item {\n    margin: 0;\n    margin-top: 1%;\n    font-size: 15px;\n}\n\n.line-device {\n    width: 100%;\n    height: 4px;\n    background-color: white;\n    border-radius: 10px;\n}\n\n.round-div-new {\n    width: 180px;\n    height: 320px;\n\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n}\n\n.purple-checkbox {\n    border-radius: 100%;\n}\n\n[type=\"radio\"]:not(:checked)+label:after {\n    opacity: 0;\n    -webkit-transform: scale(0);\n    transform: scale(0);\n}\n\n[type=\"radio\"]:checked+label:after {\n    opacity: 1;\n    -webkit-transform: scale(1);\n    transform: scale(1);\n}\n\n.loading-center {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 2131;\n}\n\n\ntd {\n    background-color: rgb(28, 28, 28);\n}\n\n\n\n\n@import url(\"https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700&display=swap\");\n\n\n::-webkit-scrollbar {\n    width: 5px;\n    height: 5px\n}\n\n::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 5px grey;\n    border-radius: 5px\n}\n\n::-webkit-scrollbar-thumb {\n    background: gray;\n    border-radius: 0\n}\n\n::-webkit-scrollbar-thumb:hover {\n    background: #b30000\n}\n\nbody,\n/* body * {\n    font-family: 'Effra'\n} */\n\nhtml,\nbody {\n    min-height: 100%;\n    margin: 0;\n    font-size: 14px;\n    background-color: #373E43;\n    color: #fff\n}\n\n/* a {\n    color: #fff !important\n} */\np {\n    color: #FFF;\n}\n\n.active {\n    background-color: #373E43\n}\n\n.wrapper {\n    min-height: 100%;\n    position: relative;\n    overflow: hidden\n}\n\n.main-header {\n    position: fixed;\n    top: 0;\n    right: 0;\n    left: 0;\n    background-color: #091114;\n    padding-left: 15.50%;\n    z-index: 1\n}\n\n.main-footer {\n    position: fixed;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    padding-left: 15.50%;\n    z-index: 1;\n    background-color: #373E43\n}\n\n.main-footer p {\n    margin-bottom: 0;\n    color: #ddd;\n    padding-bottom: 0 !important;\n    padding-top: 2px !important;\n    font-size: 13px\n}\n\n.main-sidebar,\n.left-side {\n    position: fixed;\n    top: 0;\n    left: 0;\n    min-height: 100%;\n    width: 15.50%;\n    z-index: 810;\n    background-color: #091114\n}\n\n.sidenav {\n    margin-top: 10px\n}\n\n.content-wrapper {\n    padding-top: 74px;\n    background-color: #373E43;\n    z-index: 800;\n    margin-left: 15.50%\n}\n\n.light {\n    color: #fff\n}\n\n.danger {\n    color: #F41111\n}\n\n.logo {\n    width: 90%;\n    display: block;\n    margin: auto\n}\n\n.fa-bars {\n    font-size: 22px;\n    line-height: 24px\n}\n\n.nav-text {\n    color: white\n}\n\naside a,\naside a:hover,\n.nav-link,\n.nav-link:hover,\naside p {\n    color: #fff\n}\n\naside .nav-link {\n    font-size: 14px\n}\n\n.subMenuActive {\n    padding-bottom: 10px;\n    border-bottom: 2px solid #E81941\n}\n\naside .nav-link img {\n    height: 16px;\n    vertical-align: text-bottom\n}\n\nheader .navbar .navbar-nav .nav-item {\n    text-align: center;\n    border-right: 1px solid #FFF\n}\n\nheader .navbar .navbar-nav .nav-item .nav-link {\n    vertical-align: sub;\n    /* padding:11px;padding-right:53px;*/\n    min-width: 170px;\n    font-size: 13px;\n    text-align: center\n}\n\nheader .navbar .navbar-nav .nav-item .nav-link img {\n    height: 12px;\n    margin-top: -8px;\n    margin-right: 3px\n}\n\n.nav-link-collapse:after {\n    float: left;\n    content: \"\";\n    font-family: \"FontAwesome\";\n    padding-left: 5px\n}\n\n.nav-link-show:after {\n    float: left;\n    content: \"\";\n    font-family: \"FontAwesome\"\n}\n\n.nav-item ul.nav-second-level {\n    padding-left: 0\n}\n\n.nav-item ul.nav-second-level>.nav-item {\n    padding-left: 45px\n}\n\n.nav-item ul.nav-second-level>.nav-item a {\n    position: relative;\n    padding-left: 25px\n}\n\n.nav-item ul.nav-second-level>.nav-item a img {\n    position: absolute;\n    left: 0;\n    margin: 0;\n    top: 12px\n}\n\n/* @media(min-width:992px){.sidenav{position:absolute;top:0;left:0;width:230px;height:calc(100vh - 3.5rem);margin-top:3.5rem;background:#343a40;box-sizing:border-box;border-top:1px solid rgba(0,0,0,0.3)}}*/\n/* .navbar-expand-lg .sidenav{flex-direction:column}*/\naside .sidenav .nav-item .nav-link img {\n    margin-left: 10px;\n    margin-right: 5px;\n    margin-top: -5px\n}\n\naside .sub-nav span {\n    font-size: 12px\n}\n\n.navbar-nav .nav-item:hover {\n    background-color: #373E43\n}\n\naside .sub-nav .nav-item {\n    margin-bottom: 1px\n}\n\naside .sub-nav .nav-item .nav-link {\n    background-color: #a1a6a9\n}\n\naside .sub-nav .nav-item .nav-link.active {\n    background-color: #091114\n}\n\n.auth-sec img {\n    vertical-align: middle;\n    height: 16px\n}\n\n.auth-sec {\n    padding: 10px 10px;\n    margin-top: -47px;\n    z-index: 10000;\n    right: 0;\n    position: absolute\n}\n\n.auth-sec span {\n    color: #fff;\n    font-size: 15px;\n    line-height: 14px;\n    text-transform: capitalize\n}\n\n.navbar-light .navbar-nav .nav-link {\n    font-size: 14px\n}\n\n.navbar-light .navbar-nav .nav-link img {\n    height: 16px\n}\n\n.content-wrapper .header-sec .nav-item {\n    width: 170px;\n    text-align: center;\n    border-right: 1px solid #fff\n}\n\n.card {\n    background-color: transparent;\n    margin-top: 10px;\n    border: 1px solid #151D20;\n    border-radius: 10px !important\n}\n\n.card .card-header {\n    background-color: #D3D8DB;\n    border: none !important\n}\n\n.card-box {\n    background-color: #091114;\n    color: #D3D8DB;\n    border-radius: 5px\n}\n\n.card-box h4 span {\n    font-size: 18px\n}\n\n.card-box h2 {\n    font-size: 90px\n}\n\n.card-box h2.lower-font {\n    font-size: 62px;\n    line-height: 62px\n}\n\n.card-box h2.sec-lower-font {\n    font-size: 40px;\n    line-height: 36px\n}\n\n.card-box-dark {\n    background-color: #091114;\n    color: #fff;\n    border-radius: 5px\n}\n\n.card-box-dark h3 span {\n    font-size: 16px\n}\n\n.filters .form-control {\n    width: auto;\n    min-width: 200px;\n    background-color: transparent;\n    color: #fff;\n    font-weight: 500;\n    border-radius: 10px;\n    margin-left: 8px\n}\n\n.filters .form-control+.input-group-append.close {\n    display: none !important\n}\n\n.filters .bs-searchbox .form-control {\n    margin-left: 0\n}\n\n/*.filters #executiveSummary{background:#F41111;border:1px solid #F41111}*/\n.filters button:focus {\n    outline: 0 !important;\n    box-shadow: none !important\n}\n\n.filters .btn-light {\n    background: #373E43;\n    color: white;\n    outline: 0 !important;\n    outline-offset: 0 !important;\n    border-radius: 10px !important\n}\n\n.filters .inner.show ul li a.active {\n    background: black !important\n}\n\n.filters .inner.show ul li a:active {\n    background: black !important\n}\n\n.logo.mobile {\n    display: none\n}\n\nselect::-ms-expand {\n    display: none\n}\n\n/* select{background:url(./angel-down.png)no-repeat right;background-position-x:166px;-webkit-appearance:none;-moz-appearance:none;appearance:none}*/\n.v-align-middle {\n    vertical-align: middle\n}\n\n.border-bottom-red {\n    border-bottom-color: #d43f3a !important;\n    border-bottom-width: 2px !important\n}\n\n@media only screen and(max-width:1100px) {\n    .card-box h2 {\n        font-size: 60px\n    }\n\n    .filters .form-control {\n        min-width: 130px\n    }\n\n    .card-box h4 {\n        font-size: 20px\n    }\n\n    .card-box-dark h4 {\n        font-size: 19px\n    }\n\n    .card-box-dark h3 {\n        font-size: 18px\n    }\n\n    .card-box-dark h3 span {\n        font-size: 11px\n    }\n\n    .card-box h4 span {\n        font-size: 16px\n    }\n\n    .card-box h2.lower-font {\n        font-size: 40px;\n        line-height: 60px\n    }\n\n    select {\n        background-position-x: 100px\n    }\n}\n\n@media only screen and(max-width:991px) {\n    .main-sidebar {\n        margin-top: 53px\n    }\n\n    .main-header {\n        padding-left: 0\n    }\n\n    .navbar-nav {\n        flex-direction: row\n    }\n\n    .main-sidebar .navbar-nav {\n        flex-direction: column\n    }\n\n    .nav-text {\n        text-transform: capitalize !important\n    }\n\n    .content-wrapper .header-sec .nav-item {\n        width: 130px\n    }\n\n    .filters .form-control {\n        margin-bottom: 10px\n    }\n}\n\n@media only screen and(max-width:767px) {\n    .nav-text {\n        display: none\n    }\n\n    header .navbar .navbar-nav .nav-item {\n        width: 60px\n    }\n\n    .logo.desktop {\n        display: none\n    }\n\n    .logo.mobile {\n        display: block;\n        width: 100%\n    }\n\n    .d-none-sm {\n        display: none\n    }\n\n    .ml-none-sm {\n        margin-left: 0 !important\n    }\n\n    .main-sidebar {\n        width: 50px\n    }\n\n    aside .nav-link img {\n        height: 15px\n    }\n\n    aside .sub-nav .nav-link {\n        padding-left: 8px !important\n    }\n\n    .content-wrapper {\n        margin-left: 50px\n    }\n\n    .main-footer {\n        padding-left: 50px;\n        font-size: 9px\n    }\n\n    .content-wrapper .header-sec .nav-item {\n        width: 69px\n    }\n\n    .content-wrapper .card-header .left h4 {\n        font-size: 15px\n    }\n\n    .content-wrapper .card-header .left p {\n        font-size: 10px\n    }\n\n    .content-wrapper .card-header .right {\n        margin-top: 4px !important\n    }\n\n    .filters .form-control {\n        min-width: 100%\n    }\n\n    .filters h4 {\n        margin-bottom: 5px !important\n    }\n\n    .content-wrapper .card-header .right img {\n        height: 20px !important\n    }\n\n    select {\n        background-position-x: 95%\n    }\n}\n\nselect option {\n    background-color: #373E43;\n    color: #fff\n}\n\n.active2 {\n    border-bottom: 1px solid #d90707;\n    width: 89%;\n    margin: auto\n}\n\n.content-wrapper {\n    padding-left: 15px;\n    padding-right: 15px\n}\n\n.dataTables_wrapper .dataTables_paginate .paginate_button {\n    padding: 0 !important;\n    background-color: #fff\n}\n\n.ti-stats-up {\n    color: #fff\n}\n\n.header-title {\n    color: #fff\n}\n\n.form-group label {\n    color: #fff\n}\n\n.form-control {\n    background-color: transparent;\n    color: #fff\n}\n\n#dataTable_wrapper label {\n    color: #fff\n}\n\n.chartjs-size-monitor * {\n    color: #fff !important\n}\n\ntable.dataTable tbody tr {\n    background-color: transparent !important;\n    color: #fff\n}\n\ntable.dataTable tbody td {\n    border: 1px solid #fff\n}\n\n#dataTable_info {\n    color: #fff\n}\n\n.dataTables_filter label {\n    color: #fff\n}\n\n.dataTables_length label {\n    color: #fff\n}\n\n.bg-light * {\n    background-color: #373E43;\n    color: #fff\n}\n\n.bg-light th {\n    border: 1px solid #fff !important;\n    font-size: 13px\n}\n\n#dataTable td {\n    font-size: 12px\n}\n\n.filter {\n    background-color: #000\n}\n\n.filter label {\n    margin-left: 10px;\n    margin-right: 10px\n}\n\n.filter input,\n.filter select,\n.filter label {\n    border-color: #4C9FE1 !important;\n    color: #4C9FE1 !important\n}\n\ntable.dataTable thead .sorting:before,\ntable.dataTable thead .sorting_asc:before,\ntable.dataTable thead .sorting_desc:before,\ntable.dataTable thead .sorting_asc_disabled:before,\ntable.dataTable thead .sorting_desc_disabled:before {\n    display: none !important\n}\n\ntable.dataTable thead .sorting:after,\ntable.dataTable thead .sorting_asc:after,\ntable.dataTable thead .sorting_desc:after,\ntable.dataTable thead .sorting_asc_disabled:after,\ntable.dataTable thead .sorting_desc_disabled:after {\n    display: none !important\n}\n\n.pagination a {\n    background-color: #000 !important\n}\n\n.dataTables_length {\n    display: none\n}\n\n#StoreID {\n    width: 150px;\n    height: 35px\n}\n\n#summarydate {\n    width: 235px !important;\n    height: 35px;\n    border-radius: 10px\n}\n\ntable.dataTable>tbody>tr.child ul.dtr-details>li:last-child {\n    white-space: nowrap !important\n}\n\n.bootstrap-select>.dropdown-toggle.bs-placeholder,\n.bootstrap-select>.dropdown-toggle.bs-placeholder:active,\n.bootstrap-select>.dropdown-toggle.bs-placeholder:focus,\n.bootstrap-select>.dropdown-toggle.bs-placeholder:hover {\n    color: #fff !important;\n    border-radius: 10px !important\n}\n\n.card {\n    background-color: #373E43\n}\n\n.card-bg {\n    background-color: #373E43 !important\n}\n\n.header-sec {\n    display: none\n}\n\ntable.dataTable thead th,\ntable.dataTable thead td {\n    padding: 0 18px !important;\n    border: 1px solid #ddd !important;\n    box-sizing: border-box !important;\n    border-bottom: 0 !important;\n    letter-spacing: 1px\n}\n\n.progress-sec {\n    margin-bottom: 5px;\n    margin-left: 10px;\n    clear: both\n}\n\n.header-sec .navbar-nav .nav-link {\n    padding-top: 5px !important;\n    padding-bottom: 10px !important\n}\n\ntable.dataTable tbody th,\ntable.dataTable tbody td {\n    padding: 2px 6px\n}\n\ntable.dataTable button.btn.btn-default {\n    padding: 0 5px !important;\n    font-size: 14px\n}\n\n.card .card-header .right.float-right img {\n    height: 20px;\n    padding-right: 3px;\n    padding-left: 3px\n}\n\n.userRole {\n    height: 15px\n}\n\n.BtnAddList {\n    position: absolute;\n    right: 25px;\n    top: 0;\n    z-index: 999;\n    margin-top: 75px;\n    margin-bottom: 30px\n}\n\n.userRoleTable .form-control {\n    min-width: 350px\n}\n\n.dataTables_wrapper .myfilter .dataTables_filter {\n    float: left\n}\n\n.dataTables_wrapper .mylength .dataTables_length {\n    float: right\n}\n\ntable.dataTable tbody tr {\n    font-size: 13px\n}\n\n.stockSummaryTable table.dataTable.dtr-inline.collapsed>tbody>tr[role=row]>td:first-child:before,\ntable.dataTable.dtr-inline.collapsed>tbody>tr[role=row]>th:first-child:before {\n    top: 4px !important\n}\n\n.userInfoFilter .filters {\n    display: inline\n}\n\n.userInfoFilter .dataTables_filter {\n    margin-top: -30px\n}\n\ntable.dataTable.dtr-inline.collapsed>tbody>tr[role=row]>td:first-child:before,\ntable.dataTable.dtr-inline.collapsed>tbody>tr[role=row]>th:first-child:before {\n    top: 2px !important;\n    height: 12px;\n    width: 12px\n}\n\ntable.dataTable.dtr-inline.collapsed>tbody>tr[role=row]>td:first-child,\ntable.dataTable.dtr-inline.collapsed>tbody>tr[role=row]>th:first-child {\n    padding-left: 5px\n}\n\n.stocksummery .dataTables_filter .form-control {\n    width: 280px\n}\n\n#dataTable12_wrapper .dataTables_filter .form-control {\n    width: 280px\n}\n\n/* .dataTables_filter .form-control{width:280px !important}*/\n.customNav {\n    background: #091114;\n    padding: 0 !important\n}\n\n.customNav .navbar-nav li a {\n    color: #fff\n}\n\n.customNav .navbar-nav li .dropdown-item:hover {\n    background: none !important\n}\n\nli.float-right.nav-item {\n    position: absolute;\n    right: 0\n}\n\n.customNav .dropdown-menu {\n    background: #373E43;\n    border: none !important;\n    border-radius: 0;\n    margin: 0 !important;\n    padding-top: 0;\n    text-align: left\n}\n\n.CustomsubMenu {\n    display: flex\n}\n\n.customNav .dropdown-menu .CustomsubMenu a {\n    display: inline-block;\n    position: relative;\n    margin-right: 0;\n    background: none !important;\n    padding-bottom: 7px;\n    font-size: 13px;\n    width: 170px\n}\n\n.customNav .dropdown-menu .CustomsubMenu a:after {\n    content: \"\";\n    position: absolute;\n    width: 1px;\n    height: calc(100% - 8px);\n    background: white;\n    right: 0;\n    top: 5px\n}\n\n.customNav .dropdown-menu .dropdown-item {\n    padding: .25rem 1.0rem\n}\n\n.customNav .dropdown-menu>.px-0 {\n    overflow-x: auto;\n    width: 100%;\n    overflow-y: hidden\n}\n\n.customNav .dropdown-menu>.px-0 .CustomsubMenu {\n    white-space: nowrap;\n    padding-bottom: 5px;\n    display: block;\n    font-size: 0\n}\n\n.customNav .dropdown-menu>.px-0 .CustomsubMenu a {\n    /*display:inline-block;width:170px !important;*/\n    text-align: center\n}\n\n.customNav .navbar-nav a {}\n\n.customNav .dropdown-menu .CustomsubMenu a img {\n    height: 12px;\n    margin-top: -2px;\n    margin-right: 5px\n}\n\n.customNav .dropdown-toggle::after {\n    display: none\n}\n\n.card .card-header .mb-0 {\n    font-size: 18px;\n    color: #373E43\n}\n\n.run.btn-block {\n    display: block;\n    width: 54%;\n    color: #fff;\n    background-color: #0069d9;\n    border-color: #0062cc;\n    border-radius: 10px\n}\n\n.run:hover {\n    color: #fff;\n    background-color: #0069d9;\n    border-color: #0062cc\n}\n\n.run:not(:disabled):not(.disabled).active,\n.run:not(:disabled):not(.disabled):active,\n.show>.run.dropdown-toggle {\n    color: #fff;\n    background-color: #0062cc;\n    border-color: #005cbf\n}\n\n.run.focus,\n.run:focus {\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5) !important\n}\n\n.inner_col_stock_wrapper {\n    text-align: center;\n    background: #000;\n    padding: 10px;\n    border-radius: 10px;\n    margin: 0 5px 5px 5px\n}\n\n.inner_col_stock_wrapper .main_heading_stock {\n    color: #B4BF17;\n    font-size: 14px\n}\n\n.inner_col_stock_wrapper .para {\n    color: #fff;\n    margin-bottom: 6px\n}\n\n.stockSummaryTable .left.d-inline-block {\n    font-size: 18px\n}\n\n#dashboard .dash_board {\n    border: 1px solid #707070 !important;\n    border-radius: 10px !important;\n    padding: 0 !important;\n    padding-bottom: 15px !important\n}\n\n#dashboard .dash_board .card-header {\n    width: calc(100% + 2px) !important;\n    border-radius: 10px 10px 0 0 !important;\n    margin-left: -1px;\n    margin-top: -1px\n}\n\n#dashboard .dash_board .card.second {\n    margin-top: 15px !important\n}\n\n#dashboard .dash_board .card.full {\n    height: calc(100% - 10px)\n}\n\n#dashboard .dash_board .card-body h2 {}\n\n#dashboard .dash_board .card-body h2 p {\n    margin-bottom: 0 !important;\n    color: #fff\n}\n\n#dashboard .activities {\n    height: 310px;\n    overflow: hidden;\n    overflow-y: auto\n}\n\n#dashboard .activities .card-body h3 {\n    font-size: 20px;\n    font-weight: 500;\n    margin-bottom: 20px\n}\n\n#dashboard .activities .card-body #Activities {\n    height: auto\n}\n\n#dashboard .activities .card-body #Activities p {\n    font-size: 12px;\n    font-weight: 300;\n    margin-bottom: 0.5rem;\n    line-height: 10px\n}\n\n#dashboard button.btn.dropdown-toggle.bs-placeholder.btn-light {\n    width: 50%;\n    background-color: #373E43\n}\n\n.btn-light:not(:disabled):not(.disabled):active:focus,\n.show>.btn-light.dropdown-toggle:focus,\n.btn-light.focus,\n.btn-light:focus {\n    box-shadow: none\n}\n\n.btn-light {\n    border-color: none\n}\n\n.bootstrap-select .dropdown-toggle:focus {\n    outline: 0 auto -webkit-focus-ring-color !important\n}\n\n#dashboard>.col-12 {\n    padding-left: 0 !important;\n    padding-right: 0 !important\n}\n\n#dashboard .crdBody {\n    padding: 10px 5px\n}\n\n#dashboard .crdBody p {\n    color: #C3F432;\n    font-size: 20px;\n    line-height: 5px\n}\n\n#dashboard #expectedw,\n#dashboard #totalstore,\n#dashboard #item_accuracy {\n    font-weight: bold\n}\n\n#dashboard #expectedw p,\n#dashboard #totalstore p,\n#dashboard #item_accuracy p {\n    font-weight: bold\n}\n\n#dashboard .mainsupplychaincard {\n    border-radius: 10px\n}\n\n#dashboard .mainsupplychaincard .card-header {\n    border-radius: 10px 10px 0 0\n}\n\n#dashboard .mainsupplychaincard .supplychaincardbody {\n    border-radius: 0 0 10px 10px\n}\n\n#dashboard .mainsupplychaincard .supplychaincardbody .supplychaincard {\n    height: auto\n}\n\n@media screen and(max-width:767px) {\n    #dashboard .mainsupplychaincard .supplychaincardbody .supplychaincard {\n        height: auto\n    }\n}\n\n#dashboard .mainsupplychaincard .supplychaincardbody h4,\n#dashboard .mainsupplychaincard .supplychaincardbody h6 {\n    font-size: 20px;\n    color: #fff;\n    line-height: normal;\n    font-weight: 400\n}\n\n#dashboard .mainsupplychaincard .supplychaincardbody .class_supply_week p,\n#dashboard .mainsupplychaincard .supplychaincardbody .class_supply_month p {\n    font-size: 16px;\n    color: #fff;\n    line-height: 16px;\n    font-weight: 400\n}\n\n#dashboard .mainsupplychaincard .supplychaincardbody .class_supply_week h4 span,\n#dashboard .mainsupplychaincard .supplychaincardbody .class_supply_month h4 span {\n    font-size: 55px;\n    color: #fff;\n    line-height: 65px;\n    font-weight: 400\n}\n\n#dashboard .mainsupplychaincard .supplychaincardbody .cardsupply_asn {\n    background: #091114;\n    border-color: #091114\n}\n\n#dashboard .mainsupplychaincard .supplychaincardbody .cardsupply_asn .supplymain_heading1 h6 {\n    color: #F41111\n}\n\n#dashboard .mainsupplychaincard .supplychaincardbody .cardsupply_asn .supplymain_heading2 h6 {\n    color: #15BE3C\n}\n\n#dashboard .mainsupplychaincard .supplychaincardbody .cardsupply_asn.shortage h6 {\n    color: #F41111\n}\n\n#dashboard .mainsupplychaincard .supplychaincardbody .cardsupply_asn.excess h6 {\n    color: #15BE3C\n}\n\n#dashboard .mainsupplychaincard .supplychaincardbody .cardsupply_asn h4 {\n    font-size: 100px;\n    line-height: 106px;\n    color: #fff\n}\n\n#dashboard .mainsupplychaincard .supplychaincardbody .supplychaincard p span {\n    font-size: 70px;\n    line-height: 80px;\n    color: #fff\n}\n\n#dashboard .black-card {\n    background: #091114;\n    border-color: #091114\n}\n\n#dashboard .black-card .card-body>span,\n#dashboard .black-card .card-body>span span,\n#dashboard .black-card .card-body .progress-sec p {\n    color: #fff\n}\n\n#dashboard .black-card .mainCard {\n    background-color: #2A3034;\n    border-radius: 10px\n}\n\n/* #item_accuracy p,\n#operational_accuracy p {\n    color: #000\n} */\n\n::-webkit-calendar-picker-indicator {\n    filter: invert(1)\n}\n\n.main-footer {\n    padding-bottom: 5px\n}\n\n.navbar-nav>li {\n    background: #373E43;\n    border-bottom: 1px solid #091114\n}\n\n.navbar-nav>li.active>a:after {\n    transform: rotate(0deg);\n    transition: 0.5s\n}\n\n.navbar-nav>li>a {\n    padding-left: 8px !important\n}\n\n.navbar-nav>li>a:after {\n    transform: rotate(-90deg);\n    transition: 0.5s;\n    padding-left: 0\n}\n\n.navbar-nav>li>ul>li {\n    background: #56626A;\n    position: relative\n}\n\n.navbar-nav>li>ul>li:not(:last-of-type) {\n    border-bottom: 1px solid #091114\n}\n\n.navbar-nav>li>ul>li:first-of-type {\n    border-top: 1px solid #091114\n}\n\n.navbar-nav>li>ul>li:before {\n    content: \"\";\n    position: absolute;\n    height: 0;\n    width: 2px;\n    left: 0;\n    transition: 0.5s\n}\n\n.navbar-nav>li>ul>li.active {\n    background: #091114;\n    transition: 0.5s\n}\n\n.navbar-nav>li>ul>li.active:before {\n    height: 100%;\n    background: #E81941;\n    transition: 0.5s\n}\n\n.main-header ul>li {\n    border-bottom: 0;\n    border-right: 0 !important;\n    background: #151D20\n}\n\n.main-header ul>li>a {\n    position: relative\n}\n\n.main-header ul>li>a:before {\n    content: \"\";\n    position: absolute;\n    width: 1px;\n    height: calc(100% - 8px);\n    background: white;\n    right: 0;\n    top: 5px\n}\n\n.main-header ul>li .dropdown-menu .subMenuActive {\n    position: relative;\n    border-bottom: 0\n}\n\n.main-header ul>li .dropdown-menu .subMenuActive:before {\n    content: \"\";\n    position: absolute;\n    width: calc(100% - 12px);\n    height: 2px;\n    background: #E81941;\n    border-radius: 50px;\n    left: 0;\n    right: 0;\n    margin: auto;\n    bottom: -2px\n}\n\n.top-cards {\n    min-height: auto\n}\n\n.success {\n    color: #15BE3C\n}\n\n#onehand2 .accu-onhand-vl,\n#CriticalStock .accu-onhand-vl {\n    font-size: 35px\n}\n\n#undernum p,\n#expectednum p {\n    font-size: 35px;\n    display: inline\n}\n\n#PrinterForm .container {\n    max-width: 100%;\n    padding: 0\n}\n\n#PrinterForm .container .inner_form {\n    min-height: 100%\n}\n\n#PrinterForm .container>.row {\n    margin-left: -7.5px;\n    margin-right: -7.5px\n}\n\n#PrinterForm .container>.row>div {\n    padding-left: 7.5px;\n    padding-right: 7.5px\n}\n\n#dashboard .cad .card-header h4 {\n    font-size: 18px;\n    font-weight: 500;\n    color: #373E43\n}\n\n#dashboard .cad .card-header p {\n    font-size: 15px;\n    font-weight: 300;\n    color: #373E43\n}\n\n#dashboard .cad .crdBody p {\n    font-size: 14px;\n    font-weight: 300\n}\n\n#dashboard .cad .card-body h2 p {\n    font-size: 90px;\n    font-weight: 400 !important;\n    text-align: center\n}\n\n#dashboard .cad .card-body #expectedw p {\n    text-align: center !important\n}\n\n#dashboard .cad .card-body .progress-sec p {\n    font-size: 16px;\n    display: inline-flex !important\n}\n\n#dashboard .cad .card-body span,\n#dashboard .cad .card-body h6 {\n    font-weight: 500;\n    font-size: 16px\n}\n\n#dashboard .cad .card-body .itemHeading {\n    font-weight: 400\n}\n\n#dashboard .cad .card-body .dropdown-item span {\n    font-weight: 300;\n    font-size: 16px;\n    line-height: 35px\n}\n\n#dashboard .cad .card-body .filter-option-inner-inner {\n    font-size: 16px\n}\n\n.bg-warning {\n    background-color: #39DD4C !important\n}\n\n.bg-danger {\n    background-color: #E3174E !important\n}\n\n.bg-info {\n    background-color: #47ACE2 !important\n}\n\n.pagination li a {\n    background-color: white !important;\n    color: black !important\n}\n\n#executive-summary-count-dashboard h4 {\n    font-size: 18px;\n    font-weight: 500;\n    color: #373E43\n}\n\n#executive-summary-count-dashboard p {\n    font-size: 18px;\n    font-weight: 300;\n    color: #373E43\n}\n\n#executive-summary-count-dashboard .card-box p,\n#executive-summary-count-dashboard .card-box h4 {\n    color: #fff\n}\n\n#executive-summary-count-dashboard .item-accuracy-card p {\n    font-size: 100px;\n    font-weight: 400\n}\n\n#executive-summary-count-dashboard .item-accuracy-count h2 {\n    font-size: 85px;\n    font-weight: 400\n}\n\n#executive-summary-count-dashboard .item-accuracy-front-back h2 {\n    font-size: 50px;\n    font-weight: 400\n}\n\n#executive-summary-count-dashboard .black-right-card:last-of-type {\n    padding-bottom: 22px !important\n}\n\n#executive-summary-count-dashboard .black-right-card span {\n    font-size: 25px;\n    font-weight: 500\n}\n\n#executive-summary-count-dashboard .black-right-card .small-text {\n    font-size: 16px;\n    font-weight: 300\n}\n\n#executive-summary-count-dashboard .black-right-card p {\n    font-size: 25px;\n    font-weight: 300\n}\n\n#executive-summary-count-dashboard .black-right-card h4 {\n    font-size: 18px;\n    font-weight: 300\n}\n\n.page-item.active .page-link {\n    border: 0\n}\n\n.card-header:first-child {\n    border-radius: 10px 10px 0 0;\n    padding: 8px 10px\n}\n\n.time-load-text {\n    margin: 0;\n    padding: 0 !important;\n    position: absolute;\n    right: 10px;\n    font-size: 10px !important;\n    bottom: 5px\n}\n\n.dashboard-new .card {\n    height: 100%\n}\n\n.content-wrapper .right {\n    margin-top: 11px !important\n}\n\n.content-wrapper .right img {\n    height: 25px !important\n}\n\n.last-scan-row {\n    width: calc(100% + 30px);\n    margin: 0;\n    margin-left: -15px\n}\n\n#Activities::-webkit-scrollbar {\n    width: 10px\n}\n\n#Activities::-webkit-scrollbar-track {\n    box-shadow: none\n}\n\n#Activities::-webkit-scrollbar-thumb {\n    background-color: darkgrey;\n    outline: none;\n    border-radius: 10px\n}\n\n#CountDynamic {\n    height: none\n}\n\n.crdBody h4 {\n    min-height: 27px\n}\n\n.card-header h4 {\n    font-size: 25px;\n    font-weight: 300\n}\n\n.card-header .dateTime {\n    font-size: 13px !important;\n    font-weight: 300\n}\n\n.custom-filter h4 {\n    font-size: 25px;\n    font-weight: 300\n}\n\n.custom-filter .inner.show ul li a.active {\n    background: black !important\n}\n\n.side-banner {\n    /* background-image: url(/assets/images/side-banner.png); */\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: cover\n}\n\n.dash-theme-dark.top-bar {\n    color: #fff\n}\n\n@keyframes spinner {\n    to {\n        transform: rotate(360deg)\n    }\n}\n\n.spinner:before {\n    content: '';\n    box-sizing: border-box;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 50px;\n    height: 50px;\n    margin-top: -10px;\n    margin-left: -10px;\n    border-radius: 50%;\n    border: 2px solid #ccc;\n    border-top-color: #333;\n    animation: spinner .6s linear infinite\n}\n\n.dataTables_wrapper .dataTables_processing {\n    height: 150px\n}\n\n.dataTables_wrapper .dataTables_processing {\n    min-height: 120px !important\n}\n\n.dt-buttons {\n    display: none\n}\n\n.data-tables {\n    visibility: hidden\n}\n\n.before_load_table {\n    text-align: center\n}\n\n.before_load_table img {\n    width: 100px\n}\n\n.filter_container {\n    width: 98%;\n    max-width: 100%\n}\n\n.custom-filter h4 {\n    margin-left: 15px\n}\n\n#Onhand,\n#Count,\n#back,\n#front {\n    font-size: 27px !important\n}\n\n#Onhand span,\n#Count span,\n#back span,\n#front span {\n    font-size: 27px !important\n}\n\n.dropdown-menu {\n    background-color: #151d20;\n    color: #fff\n}\n\n.dropdown-item:focus,\n.dropdown-item:hover {\n    background-color: #171b1d\n}\n\ntable.dataTable tbody {\n    background-color: #1b1f22\n}\n\ntable.dataTable tbody td {\n    padding: 0 !important;\n    border-top: 0 !important\n}\n\n.dataTables_wrapper.no-footer .dataTables_scrollBody {\n    border-bottom: 0 !important\n}\n\n.BtnAdd {\n    border-radius: 10px\n}\n\n.error {\n    color: red !important;\n}\n\ndiv.dataTables_wrapper div.dataTables_processing {\n    background: transparent !important;\n    color: #fff !important;\n    border: none !important;\n}\n\n@media print {\n\n    html,\n    body {\n        border: 1px solid white;\n        height: 99%;\n        page-break-after: avoid;\n        page-break-before: avoid;\n        color: #000;\n        background: #fff\n    }\n}\n\ninput[disabled] {\n    background-color: rgb(180, 180, 180) !important;\n}\n\n.page-link-btn {\n    color: white !important;\n}\n\n/* .MuiInputBase-input {\n    height: 0.7rem!important;\n  } */\n\n.button-custom {\n    background: #3390fa;\n    border-radius: 10px;\n    width: max-content;\n    padding: 5px 10px;\n    color: #fff;\n    text-decoration: none;\n    font-size: 1em;\n    margin: 0 15px;\n}\n\n/* Hover state animation applied here */\n.button-custom:hover {\n    -webkit-animation: hover 1200ms linear 2 alternate;\n    animation: hover 1200ms linear 2 alternate;\n}\n\n/* Active state animation applied here */\n.button-custom:active {\n    -webkit-animation: active 1200ms ease 1 alternate;\n    animation: active 1200ms ease 1 alternate;\n    background: #5F9BE0;\n}\n\n.gray {\n    background: #D2D2D2;\n}\n\n.gray:active {\n    background: #b9b9b9;\n}\n\n/* Active state animation keyframes below */\n\n@-webkit-keyframes active {\n    0% {\n        transform: scale(1, 1);\n    }\n\n    90% {\n        transform: scale(.9, .88);\n    }\n\n    100% {\n        transform: scale(.92, .9);\n    }\n}\n\n@keyframes active {\n    0% {\n        transform: scale(1, 1);\n    }\n\n    90% {\n        transform: scale(.9, .88);\n    }\n\n    100% {\n        transform: scale(.92, .9);\n    }\n}\n\n/* Hover state animation keyframes below */\n\n@-webkit-keyframes hover {\n    0% {\n        -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    1.8% {\n        -webkit-transform: matrix3d(1.016, 0, 0, 0, 0, 1.037, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.016, 0, 0, 0, 0, 1.037, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    3.5% {\n        -webkit-transform: matrix3d(1.033, 0, 0, 0, 0, 1.094, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.033, 0, 0, 0, 0, 1.094, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    4.7% {\n        -webkit-transform: matrix3d(1.045, 0, 0, 0, 0, 1.129, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.045, 0, 0, 0, 0, 1.129, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    5.31% {\n        -webkit-transform: matrix3d(1.051, 0, 0, 0, 0, 1.142, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.051, 0, 0, 0, 0, 1.142, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    7.01% {\n        -webkit-transform: matrix3d(1.068, 0, 0, 0, 0, 1.158, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.068, 0, 0, 0, 0, 1.158, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    8.91% {\n        -webkit-transform: matrix3d(1.084, 0, 0, 0, 0, 1.141, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.084, 0, 0, 0, 0, 1.141, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    9.41% {\n        -webkit-transform: matrix3d(1.088, 0, 0, 0, 0, 1.132, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.088, 0, 0, 0, 0, 1.132, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    10.71% {\n        -webkit-transform: matrix3d(1.097, 0, 0, 0, 0, 1.107, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.097, 0, 0, 0, 0, 1.107, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    12.61% {\n        -webkit-transform: matrix3d(1.108, 0, 0, 0, 0, 1.077, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.108, 0, 0, 0, 0, 1.077, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    14.11% {\n        -webkit-transform: matrix3d(1.114, 0, 0, 0, 0, 1.067, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.114, 0, 0, 0, 0, 1.067, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    14.41% {\n        -webkit-transform: matrix3d(1.115, 0, 0, 0, 0, 1.067, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.115, 0, 0, 0, 0, 1.067, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    16.32% {\n        -webkit-transform: matrix3d(1.119, 0, 0, 0, 0, 1.077, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.119, 0, 0, 0, 0, 1.077, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    18.12% {\n        -webkit-transform: matrix3d(1.121, 0, 0, 0, 0, 1.096, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.121, 0, 0, 0, 0, 1.096, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    18.72% {\n        -webkit-transform: matrix3d(1.121, 0, 0, 0, 0, 1.102, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.121, 0, 0, 0, 0, 1.102, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    20.02% {\n        -webkit-transform: matrix3d(1.121, 0, 0, 0, 0, 1.113, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.121, 0, 0, 0, 0, 1.113, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    21.82% {\n        -webkit-transform: matrix3d(1.119, 0, 0, 0, 0, 1.119, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.119, 0, 0, 0, 0, 1.119, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    24.32% {\n        -webkit-transform: matrix3d(1.115, 0, 0, 0, 0, 1.11, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.115, 0, 0, 0, 0, 1.11, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    25.53% {\n        -webkit-transform: matrix3d(1.113, 0, 0, 0, 0, 1.102, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.113, 0, 0, 0, 0, 1.102, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    29.23% {\n        -webkit-transform: matrix3d(1.106, 0, 0, 0, 0, 1.089, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.106, 0, 0, 0, 0, 1.089, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    29.93% {\n        -webkit-transform: matrix3d(1.105, 0, 0, 0, 0, 1.09, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.105, 0, 0, 0, 0, 1.09, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    35.54% {\n        -webkit-transform: matrix3d(1.098, 0, 0, 0, 0, 1.105, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.098, 0, 0, 0, 0, 1.105, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    36.64% {\n        -webkit-transform: matrix3d(1.097, 0, 0, 0, 0, 1.106, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.097, 0, 0, 0, 0, 1.106, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    41.04% {\n        -webkit-transform: matrix3d(1.096, 0, 0, 0, 0, 1.099, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.096, 0, 0, 0, 0, 1.099, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    44.04% {\n        -webkit-transform: matrix3d(1.096, 0, 0, 0, 0, 1.097, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.096, 0, 0, 0, 0, 1.097, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    51.45% {\n        -webkit-transform: matrix3d(1.099, 0, 0, 0, 0, 1.102, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.099, 0, 0, 0, 0, 1.102, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    52.15% {\n        -webkit-transform: matrix3d(1.099, 0, 0, 0, 0, 1.102, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.099, 0, 0, 0, 0, 1.102, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    58.86% {\n        -webkit-transform: matrix3d(1.101, 0, 0, 0, 0, 1.099, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.101, 0, 0, 0, 0, 1.099, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    63.26% {\n        -webkit-transform: matrix3d(1.101, 0, 0, 0, 0, 1.1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.101, 0, 0, 0, 0, 1.1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    66.27% {\n        -webkit-transform: matrix3d(1.101, 0, 0, 0, 0, 1.101, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.101, 0, 0, 0, 0, 1.101, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    73.77% {\n        -webkit-transform: matrix3d(1.1, 0, 0, 0, 0, 1.1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.1, 0, 0, 0, 0, 1.1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    81.18% {\n        -webkit-transform: matrix3d(1.1, 0, 0, 0, 0, 1.1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.1, 0, 0, 0, 0, 1.1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    85.49% {\n        -webkit-transform: matrix3d(1.1, 0, 0, 0, 0, 1.1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.1, 0, 0, 0, 0, 1.1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    88.59% {\n        -webkit-transform: matrix3d(1.1, 0, 0, 0, 0, 1.1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.1, 0, 0, 0, 0, 1.1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    96% {\n        -webkit-transform: matrix3d(1.1, 0, 0, 0, 0, 1.1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.1, 0, 0, 0, 0, 1.1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    100% {\n        -webkit-transform: matrix3d(1.1, 0, 0, 0, 0, 1.1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.1, 0, 0, 0, 0, 1.1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n}\n\n@keyframes hover {\n    0% {\n        -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    1.8% {\n        -webkit-transform: matrix3d(1.016, 0, 0, 0, 0, 1.037, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.016, 0, 0, 0, 0, 1.037, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    3.5% {\n        -webkit-transform: matrix3d(1.033, 0, 0, 0, 0, 1.094, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.033, 0, 0, 0, 0, 1.094, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    4.7% {\n        -webkit-transform: matrix3d(1.045, 0, 0, 0, 0, 1.129, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.045, 0, 0, 0, 0, 1.129, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    5.31% {\n        -webkit-transform: matrix3d(1.051, 0, 0, 0, 0, 1.142, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.051, 0, 0, 0, 0, 1.142, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    7.01% {\n        -webkit-transform: matrix3d(1.068, 0, 0, 0, 0, 1.158, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.068, 0, 0, 0, 0, 1.158, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    8.91% {\n        -webkit-transform: matrix3d(1.084, 0, 0, 0, 0, 1.141, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.084, 0, 0, 0, 0, 1.141, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    9.41% {\n        -webkit-transform: matrix3d(1.088, 0, 0, 0, 0, 1.132, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.088, 0, 0, 0, 0, 1.132, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    10.71% {\n        -webkit-transform: matrix3d(1.097, 0, 0, 0, 0, 1.107, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.097, 0, 0, 0, 0, 1.107, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    12.61% {\n        -webkit-transform: matrix3d(1.108, 0, 0, 0, 0, 1.077, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.108, 0, 0, 0, 0, 1.077, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    14.11% {\n        -webkit-transform: matrix3d(1.114, 0, 0, 0, 0, 1.067, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.114, 0, 0, 0, 0, 1.067, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    14.41% {\n        -webkit-transform: matrix3d(1.115, 0, 0, 0, 0, 1.067, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.115, 0, 0, 0, 0, 1.067, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    16.32% {\n        -webkit-transform: matrix3d(1.119, 0, 0, 0, 0, 1.077, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.119, 0, 0, 0, 0, 1.077, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    18.12% {\n        -webkit-transform: matrix3d(1.121, 0, 0, 0, 0, 1.096, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.121, 0, 0, 0, 0, 1.096, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    18.72% {\n        -webkit-transform: matrix3d(1.121, 0, 0, 0, 0, 1.102, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.121, 0, 0, 0, 0, 1.102, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    20.02% {\n        -webkit-transform: matrix3d(1.121, 0, 0, 0, 0, 1.113, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.121, 0, 0, 0, 0, 1.113, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    21.82% {\n        -webkit-transform: matrix3d(1.119, 0, 0, 0, 0, 1.119, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.119, 0, 0, 0, 0, 1.119, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    24.32% {\n        -webkit-transform: matrix3d(1.115, 0, 0, 0, 0, 1.11, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.115, 0, 0, 0, 0, 1.11, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    25.53% {\n        -webkit-transform: matrix3d(1.113, 0, 0, 0, 0, 1.102, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.113, 0, 0, 0, 0, 1.102, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    29.23% {\n        -webkit-transform: matrix3d(1.106, 0, 0, 0, 0, 1.089, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.106, 0, 0, 0, 0, 1.089, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    29.93% {\n        -webkit-transform: matrix3d(1.105, 0, 0, 0, 0, 1.09, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.105, 0, 0, 0, 0, 1.09, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    35.54% {\n        -webkit-transform: matrix3d(1.098, 0, 0, 0, 0, 1.105, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.098, 0, 0, 0, 0, 1.105, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    36.64% {\n        -webkit-transform: matrix3d(1.097, 0, 0, 0, 0, 1.106, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.097, 0, 0, 0, 0, 1.106, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    41.04% {\n        -webkit-transform: matrix3d(1.096, 0, 0, 0, 0, 1.099, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.096, 0, 0, 0, 0, 1.099, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    44.04% {\n        -webkit-transform: matrix3d(1.096, 0, 0, 0, 0, 1.097, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.096, 0, 0, 0, 0, 1.097, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    51.45% {\n        -webkit-transform: matrix3d(1.099, 0, 0, 0, 0, 1.102, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.099, 0, 0, 0, 0, 1.102, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    52.15% {\n        -webkit-transform: matrix3d(1.099, 0, 0, 0, 0, 1.102, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.099, 0, 0, 0, 0, 1.102, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    58.86% {\n        -webkit-transform: matrix3d(1.101, 0, 0, 0, 0, 1.099, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.101, 0, 0, 0, 0, 1.099, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    63.26% {\n        -webkit-transform: matrix3d(1.101, 0, 0, 0, 0, 1.1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.101, 0, 0, 0, 0, 1.1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    66.27% {\n        -webkit-transform: matrix3d(1.101, 0, 0, 0, 0, 1.101, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.101, 0, 0, 0, 0, 1.101, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    73.77% {\n        -webkit-transform: matrix3d(1.1, 0, 0, 0, 0, 1.1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.1, 0, 0, 0, 0, 1.1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    81.18% {\n        -webkit-transform: matrix3d(1.1, 0, 0, 0, 0, 1.1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.1, 0, 0, 0, 0, 1.1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    85.49% {\n        -webkit-transform: matrix3d(1.1, 0, 0, 0, 0, 1.1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.1, 0, 0, 0, 0, 1.1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    88.59% {\n        -webkit-transform: matrix3d(1.1, 0, 0, 0, 0, 1.1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.1, 0, 0, 0, 0, 1.1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    96% {\n        -webkit-transform: matrix3d(1.1, 0, 0, 0, 0, 1.1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.1, 0, 0, 0, 0, 1.1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n\n    100% {\n        -webkit-transform: matrix3d(1.1, 0, 0, 0, 0, 1.1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n        transform: matrix3d(1.1, 0, 0, 0, 0, 1.1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);\n    }\n}\n\n.printer-modal .MuiPaper-root {\n    background-color: #555656!important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
